var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/FormCheckbox.tsx
import { Checkbox } from "@utdanningsdirektoratet/lisa";
import { Controller } from "react-hook-form";
import { jsx } from "react/jsx-runtime";
function FormCheckbox(props) {
  const _a = props, { name, control } = _a, checkboxProps = __objRest(_a, ["name", "control"]);
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name,
      control,
      render: ({ field }) => {
        return /* @__PURE__ */ jsx(
          Checkbox,
          __spreadProps(__spreadValues({}, checkboxProps), {
            onChange: (isChecked) => field.onChange(!!isChecked),
            checked: field.value
          })
        );
      }
    }
  );
}

// src/components/FormDatepicker.tsx
import { useController } from "react-hook-form";
import { Datepicker, useDatepicker } from "@utdanningsdirektoratet/lisa";
import { jsx as jsx2 } from "react/jsx-runtime";
function useFormDatepicker(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, datepickerProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController({ name, control, rules });
  return useDatepicker(__spreadProps(__spreadValues({}, datepickerProps), {
    onChange: field.onChange,
    // @ts-ignore
    value: field.value,
    // @ts-ignore
    errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message
  }));
}
function FormDatepicker(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, datepickerProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController({ name, control, rules });
  return /* @__PURE__ */ jsx2(
    Datepicker,
    __spreadProps(__spreadValues({}, datepickerProps), {
      onChange: field.onChange,
      value: field.value,
      errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message
    })
  );
}

// src/components/FormInputField.tsx
import { FormComponentWrapper, useInputField } from "@utdanningsdirektoratet/lisa";
import { useController as useController2 } from "react-hook-form";
import { jsxs } from "react/jsx-runtime";
function FormInputField(props) {
  const { label, input, errorMessage } = useFormInputField(props);
  return /* @__PURE__ */ jsxs(FormComponentWrapper, { className: props.className, children: [
    label,
    input,
    errorMessage
  ] });
}
function useFormInputField(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, inputProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController2({ name, control, rules });
  const { label, input, errorMessage } = useInputField(__spreadProps(__spreadValues({}, inputProps), {
    // @ts-ignore
    value: field.value,
    handleChange: field.onChange,
    // @ts-ignore
    errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message,
    name
  }));
  return {
    label,
    input,
    errorMessage
  };
}

// src/components/FormSelect.tsx
import { Select, useSelect } from "@utdanningsdirektoratet/lisa";
import { useController as useController3 } from "react-hook-form";
import { jsx as jsx3 } from "react/jsx-runtime";
function useFormSelect(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, selectProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController3({ name, control, rules });
  return useSelect(__spreadProps(__spreadValues({}, selectProps), {
    onChange: field.onChange,
    // @ts-ignore
    value: field.value,
    // @ts-ignore
    errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message
  }));
}
function FormSelect(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, selectProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController3({ name, control, rules });
  return /* @__PURE__ */ jsx3(
    Select,
    __spreadProps(__spreadValues({}, selectProps), {
      onChange: field.onChange,
      value: field.value,
      errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message
    })
  );
}

// src/components/FormTextArea.tsx
import { FormComponentWrapper as FormComponentWrapper3 } from "@utdanningsdirektoratet/lisa";
import { useController as useController4 } from "react-hook-form";
import styled9 from "styled-components";

// ../udir-lisa/src/components/TextArea/TextArea.tsx
import { useId } from "react";
import styled8 from "styled-components";

// ../udir-lisa-tokens/dist/index.mjs
import { css } from "styled-components";
import { css as css2 } from "styled-components";
import { css as css3 } from "styled-components";
import { css as css4 } from "styled-components";
import { css as css5 } from "styled-components";
import { css as css6 } from "styled-components";
var colors = {
  // "Støttefarger"
  svart: "#1A1A1A",
  gr\u00E5100: "#F9F9F9",
  gr\u00E5200: "#F1F1F1",
  gr\u00E5300: "#EAEAEA",
  gr\u00E5400: "#E6E6E6",
  gr\u00E5500: "#BFBFBF",
  gr\u00E5600: "#999999",
  gr\u00E5700: "#737373",
  gr\u00E5800: "#666666",
  gr\u00E5900: "#303030",
  hvit: "#FFFFFF",
  // "Fargepalett"
  gr\u00F8nn200: "#E3F2EB",
  gr\u00F8nn300: "#94CAAE",
  gr\u00F8nn400: "#7DBF9D",
  gr\u00F8nn500: "#3B7858",
  gr\u00F8nn600: "#254B38",
  eggeskall300: "#F6EFE4",
  eggeskall400: "#F2E8DA",
  eggeskall500: "#D6B689",
  eggeskall600: "#8C6631",
  eggeskall700: "#5E4521",
  fersken300: "#F8ECE6",
  fersken400: "#EED0C3",
  fersken500: "#DC9E83",
  fersken600: "#A7532F",
  fersken700: "#63321C",
  lysAzur300: "#EAEAF5",
  lysAzur400: "#E2E3F1",
  lysAzur500: "#C7C9E3",
  lysAzur600: "#999CBF",
  lysAzur700: "#666883",
  st\u00E5lbl\u00E5200: "#F5F7F9",
  st\u00E5lbl\u00E5300: "#EBEEF3",
  st\u00E5lbl\u00E5400: "#BAC6D8",
  st\u00E5lbl\u00E5500: "#99ABC5",
  st\u00E5lbl\u00E5600: "#51698F",
  st\u00E5lbl\u00E5700: "#2E3C51",
  skifer200: "#ECEFF2",
  skifer300: "#A0B1BF",
  skifer400: "#6D889D",
  skifer500: "#546B7D",
  skifer600: "#191D24",
  r\u00F8d200: "#FFEBEE",
  r\u00F8d300: "#FFCDD2",
  r\u00F8d400: "#EF9A9A",
  r\u00F8d500: "#EF5350",
  r\u00F8d600: "#C62828",
  oransje200: "#FFF3E0",
  oransje300: "#FFCC80",
  oransje400: "#FFA726",
  oransje500: "#FB8C00",
  oransje600: "#EF6C00",
  bl\u00E5: "#00468E"
};
var colorTypeToHex = (colorType) => {
  var _a;
  return (_a = colors[colorType]) != null ? _a : colorType;
};
var semanticColors = {
  success: {
    /** grønn200 */
    background: colors.gr\u00F8nn200,
    /** grønn600 */
    foreground: colors.gr\u00F8nn600
  },
  error: {
    background: colors.r\u00F8d200,
    foreground: colors.r\u00F8d600,
    text: (colorTheme) => colorTheme === "dark" ? colors.oransje600 : colors.r\u00F8d600,
    icon: (colorTheme) => colorTheme === "dark" ? colors.oransje600 : colors.r\u00F8d600
  },
  info: {
    background: colors.st\u00E5lbl\u00E5200,
    foreground: colors.st\u00E5lbl\u00E5700
  },
  warning: colors.oransje600,
  hover: (colorTheme) => colorTheme === "dark" ? colors.lysAzur500 : colors.bl\u00E5,
  text: (colorTheme) => colorTheme === "dark" ? colors.hvit : colors.svart,
  textDisabled: (colorTheme) => colorTheme === "dark" ? colors.gr\u00E5500 : colors.gr\u00E5800,
  focus: (colorTheme) => colorTheme === "dark" ? colors.hvit : colors.bl\u00E5
};
var rem = (pixelSize) => `${pixelSize / 16}rem`;
var borderRadius = {
  /** 4px */
  small: rem(4),
  /** 6px */
  medium: rem(6),
  /** 8px */
  large: rem(8),
  circle: "9999px"
};
var borderWidth = {
  /** 1px */
  xsmall: "1px",
  /** 2px */
  small: "2px",
  /** 3px */
  medium: "3px",
  /** 6px */
  large: "6px"
};
var boxShadow = {
  small: css`
		box-shadow: 0px 3px 5px rgba(19, 19, 19, 0.15);
	`,
  medium: css`
		box-shadow: 0px 3px 5px rgba(19, 19, 19, 0.35);
	`,
  dropdown: (direction) => direction === "down" ? css`
					box-shadow: 0px 4px 4px rgba(19, 19, 19, 0.2);
			  ` : css`
					box-shadow: 0px -4px 4px rgba(19, 19, 19, 0.2);
			  `
};
var breakpoints = {
  value: {
    xsmall: 600,
    small: 900,
    medium: 1200,
    large: 1536
  },
  px: {
    xsmall: "600px",
    small: "900px",
    medium: "1200px",
    large: "1536px"
  },
  rem: {
    xsmall: rem(600),
    small: rem(900),
    medium: rem(1200),
    large: rem(1536)
  }
};
var spacing = (amount) => typeof amount === "number" ? rem(amount) : amount;
function _spacing(type, dirOrS1, s2, s3, s4) {
  const s2String = s2 !== void 0 ? " " + spacing(s2) : "";
  const s3s4 = s3 !== void 0 && s4 !== void 0 ? ` ${spacing(s3)} ${spacing(s4)}` : "";
  if (isSpacingAmount(dirOrS1)) {
    return `${type}: ${spacing(dirOrS1)}${s2String}${s3s4};`;
  }
  if (dirOrS1 === "x") {
    return `${type}-left:${s2String};${type}-right:${s2String};`;
  } else if (dirOrS1 === "y") {
    return `${type}-top:${s2String};${type}-bottom:${s2String};`;
  }
  return `${type}-${dirOrS1}:${s2String}${s3s4};`;
}
function isSpacingAmount(s) {
  return typeof s === "number" || s === "auto";
}
function margin(dirOrS1, s2, s3, s4) {
  return _spacing("margin", dirOrS1, s2, s3, s4);
}
function padding(dirOrS1, s2, s3, s4) {
  return _spacing("padding", dirOrS1, s2, s3, s4);
}
var transitionTime = {
  /** 0.1s */
  small: "0.1s",
  /** 0.3s */
  medium: "0.3s"
};
var shakeEffect = css4`
	animation: shake ${transitionTime.medium};

	// TODO: Spør Sigurd om transition time og animasjon
	/* prettier-ignore */
	@keyframes shake {
		0% { transform: translateX(3px) }
		30% {transform: translateX(-3px) }
		/* 30% {transform: translateX(3px) }
		40% {transform: translateX(-3px) } */
		55% {transform: translateX(3px) }
		75% {transform: translateX(-3px) }
		100% { transform: translateX(0) }
}
`;
var Weight = /* @__PURE__ */ ((Weight2) => {
  Weight2[Weight2["Regular"] = 400] = "Regular";
  Weight2[Weight2["Medium"] = 500] = "Medium";
  Weight2[Weight2["Semibold"] = 600] = "Semibold";
  return Weight2;
})(Weight || {});
var createTextStyle = (fontFamily, fontSize, fontWeight, lineHeight) => ({
  fontFamily: `${fontFamily},'udir_font',Arial,Helvetica,sans-serif`,
  fontSize,
  fontWeight,
  lineHeight
});
var textStyleObjects = {
  "display-large": createTextStyle("Montserrat", 44, 500, 1.5),
  "display-medium": createTextStyle("Montserrat", 32, 500, 1.5),
  "display-small": createTextStyle("Montserrat", 26, 500, 1.5),
  "headline-large": createTextStyle("Montserrat", 30, 500, 1.5),
  "headline-medium": createTextStyle("Montserrat", 26, 500, 1.5),
  "headline-small": createTextStyle("Montserrat", 22, 500, 1.5),
  "title-large": createTextStyle("Montserrat", 20, 500, 1.5),
  "title-medium": createTextStyle("Montserrat", 18, 500, 1.5),
  "title-small": createTextStyle("Montserrat", 18, 500, 1.5),
  "subtitle-large": createTextStyle("Montserrat", 16, 500, 1.5),
  "subtitle-medium": createTextStyle("Montserrat", 16, 500, 1.5),
  "subtitle-small": createTextStyle("Montserrat", 16, 500, 1.5),
  body: createTextStyle("Roboto", 16, 400, 1.5),
  bodyBold: createTextStyle("Roboto", 16, 500, 1.5),
  label: createTextStyle("Roboto", 14, 400, 1.5),
  labelBold: createTextStyle("Roboto", 14, 500, 1.5)
};
var createStyleFragment = (textStyle) => css5`
	font-family: ${textStyle.fontFamily};
	font-size: ${rem(textStyle.fontSize)};
	font-weight: ${textStyle.fontWeight};
	line-height: ${textStyle.lineHeight};
	strong {
		font-weight: ${600};
	}
`;
var createDynamicStyleFragment = (small, medium, large) => css5`
	${createStyleFragment(small)};
	@media screen and (min-width: ${breakpoints.px.xsmall}) {
		${createStyleFragment(medium)};
	}
	@media screen and (min-width: ${breakpoints.px.small}) {
		${createStyleFragment(large)}
	}
`;
var textStyles = {
  "display-large": createStyleFragment(textStyleObjects["display-large"]),
  "display-medium": createStyleFragment(textStyleObjects["display-medium"]),
  "display-small": createStyleFragment(textStyleObjects["display-small"]),
  "headline-large": createStyleFragment(textStyleObjects["headline-large"]),
  "headline-medium": createStyleFragment(textStyleObjects["headline-medium"]),
  "headline-small": createStyleFragment(textStyleObjects["headline-small"]),
  "title-large": createStyleFragment(textStyleObjects["title-large"]),
  "title-medium": createStyleFragment(textStyleObjects["title-medium"]),
  "title-small": createStyleFragment(textStyleObjects["title-small"]),
  "subtitle-large": createStyleFragment(textStyleObjects["subtitle-large"]),
  "subtitle-medium": createStyleFragment(textStyleObjects["subtitle-medium"]),
  "subtitle-small": createStyleFragment(textStyleObjects["subtitle-small"]),
  body: createStyleFragment(textStyleObjects["body"]),
  bodyBold: createStyleFragment(textStyleObjects["bodyBold"]),
  label: createStyleFragment(textStyleObjects["label"]),
  labelBold: createStyleFragment(textStyleObjects["labelBold"]),
  display: createDynamicStyleFragment(
    textStyleObjects["display-small"],
    textStyleObjects["display-medium"],
    textStyleObjects["display-large"]
  ),
  headline: createDynamicStyleFragment(
    textStyleObjects["headline-small"],
    textStyleObjects["headline-medium"],
    textStyleObjects["headline-large"]
  ),
  title: createDynamicStyleFragment(
    textStyleObjects["title-small"],
    textStyleObjects["title-medium"],
    textStyleObjects["title-large"]
  ),
  subtitle: createDynamicStyleFragment(
    textStyleObjects["subtitle-small"],
    textStyleObjects["subtitle-medium"],
    textStyleObjects["subtitle-large"]
  ),
  get: (style) => textStyles[style]
};
var getTextStyle = (defaultType) => css6`
	${(props) => {
  var _a;
  return textStyles.get((_a = props.textStyle) != null ? _a : defaultType);
}}
	color: ${(props) => getColorHex(props.textColor)};
`;
var getColorHex = (textColor) => {
  if (typeof textColor === "string") {
    return colorTypeToHex(textColor);
  } else {
    return semanticColors.text();
  }
};

// ../udir-lisa/src/components/Typography/Text.tsx
import styled from "styled-components";
var Text = styled.div`
	${getTextStyle("body")}
`;
var TextBlockSpan = styled(Text).attrs({
  as: "span"
})`
	color: ${(props) => {
  var _a;
  return semanticColors.text((_a = props.colorTheme) != null ? _a : "light");
}};
	display: block;
`;

// ../udir-lisa/src/components/Typography/Label.tsx
import styled2 from "styled-components";

// ../udir-lisa/src/utils/utils.ts
import { css as css7 } from "styled-components";
var visuallyHide = css7`
	position: absolute;
	display: inline-block;
	overflow: hidden;
	clip: rect(0 0 0 0);
	height: 1px;
	width: 1px;
	margin: -1px;
	padding: 0;
	border: 0;
`;
var visuallyHideNonFocusableElements = css7`
	position: absolute;
	left: -10000px;
	top: auto;
	width: 1px;
	height: 1px;
	overflow: hidden;
`;

// ../udir-lisa/src/components/Typography/Label.tsx
var Label = styled2.label`
	${getTextStyle("labelBold")}
	${({ visuallyHidden = false }) => visuallyHidden && visuallyHideNonFocusableElements};
	color: ${(props) => semanticColors.text(props.colorTheme)};
	em {
		font-weight: ${Weight.Regular};
	}
	display: inline-block;
`;
var LabelWithErrorShake = styled2(Label)`
	${(props) => props.hasErrorMessage && shakeEffect};
`;
var defaultProps = {
  colorTheme: "light"
};
Label.defaultProps = defaultProps;

// ../udir-lisa/src/components/InputField/inputStyles.ts
import { css as css8 } from "styled-components";
var getInputContainerBorderColor = (props) => {
  if (props.hasErrorMessage) {
    return semanticColors.error.text("light");
  }
  if (props.hideUnderline) {
    return "transparent";
  }
  if (props.$disabled) {
    return colors.gr\u00E5500;
  }
  if (props.hasFocus) {
    return colors.skifer400;
  }
  return colors.svart;
};
var getInputContainerBackgroundColor = (props) => {
  if (props.$disabled) {
    return colors.gr\u00E5200;
  }
  if (props.hasFocus) {
    return colors.lysAzur300;
  }
  return colors.gr\u00E5100;
};
var inputContainerCss = css8`
	${textStyles.body}
	border-top-left-radius: ${borderRadius.small};
	border-top-right-radius: ${borderRadius.small};
	border-bottom: ${borderWidth.medium} solid ${(props) => getInputContainerBorderColor(props)};
	background-color: ${(props) => getInputContainerBackgroundColor(props)};

	&:hover {
		background-color: ${(props) => getInputContainerBackgroundColor(__spreadProps(__spreadValues({}, props), { hasFocus: true }))};
		${(props) => !props.$disabled && boxShadow.small}
	}

	&:focus-within {
		border-color: ${(props) => getInputContainerBorderColor(__spreadProps(__spreadValues({}, props), { hasFocus: true }))};
		background-color: ${colors.lysAzur300};
		${boxShadow.small}
	}

	&:focus:not(:focus-visible) {
		outline: none;
	}
`;
var placeholderStyling = css8`
	&::placeholder,
	&::-webkit-input-placeholder,
	&::-moz-placeholder,
	&:-ms-input-placeholder {
		color: ${colors.gr\u00E5800};
	}
`;
var inputCss = css8`
	${placeholderStyling}
	${textStyles.body}
	border-radius: ${borderRadius.small};
	background-color: inherit;
	${padding(0, 20, 0, 8)};
	color: ${semanticColors.text()};
	outline: none;
	border: none;
	min-width: 0;

	&:disabled {
		cursor: not-allowed;
		color: ${semanticColors.textDisabled("light")};
	}
`;
var defaultInputHeight = rem(40);

// ../udir-lisa/src/shared/components/ErrorText.tsx
import styled6 from "styled-components";

// ../udir-lisa/src/components/Icon/Svg.tsx
import styled3, { css as css9 } from "styled-components";
import { jsx as jsx4 } from "react/jsx-runtime";
var defaultProps2 = {
  ariaHidden: true
};
var getSize = (size) => {
  if (typeof size === "number")
    return size + "px";
  else
    return "16px";
};
var getRotation = (direction) => {
  switch (direction) {
    case "down":
      return 180;
    case "right":
      return 90;
    case "left":
      return -90;
    default:
      return 0;
  }
};
var StyledSvg = styled3.svg.attrs((props) => {
  var _a;
  return {
    viewBox: props.viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": (_a = props.ariaLabel) != null ? _a : props.defaultLabel,
    "aria-hidden": !!props.ariaHidden,
    fill: "currentColor"
  };
})`
	width: ${(props) => getSize(props.$size)};
	height: ${(props) => getSize(props.$size)};
	overflow: visible;
	margin: 0;
	transition: all 0.3s ease, color 0s;
	color: ${(props) => {
  if (typeof props.iconColor === "string") {
    return colorTypeToHex(props.iconColor);
  } else if (typeof props.pictogramColor === "string") {
    return colorTypeToHex(props.pictogramColor);
  } else {
    return "inherit";
  }
}};

	${(props) => props.animateDirection && css9`
			g {
				transition: transform ${transitionTime.medium} ease-out;
			}
		`}
`;
var findViewBoxMidCoords = (viewBox) => {
  const [minX, minY, width, height] = viewBox.split(" ").map(parseFloat);
  return width / 2 + minX + " " + (height / 2 + minY);
};
var Svg = (_a) => {
  var _b = _a, { direction, children } = _b, props = __objRest(_b, ["direction", "children"]);
  return /* @__PURE__ */ jsx4(StyledSvg, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx4("g", { transform: `rotate(${getRotation(direction)} ${findViewBoxMidCoords(props.viewBox)})`, children }) }));
};
Svg.defaultProps = defaultProps2;

// ../udir-lisa/src/components/Icon/icons/Arrow.tsx
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var getArrowLabel = (direction) => {
  switch (direction) {
    case "right":
      return "Pil h\xF8yre";
    case "down":
      return "Pil ned";
    case "left":
      return "Pil venstre";
    case "up":
    default:
      return "Pil opp";
  }
};
var ArrowIcon = (props) => {
  return /* @__PURE__ */ jsxs2(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 27 32", defaultLabel: getArrowLabel(props.direction) }, props), { children: [
    /* @__PURE__ */ jsx5(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9918 3.41355L15.0097 30.9993L13.0097 31.0006L12.9918 3.41481L2.70563 13.7144C2.31536 14.1052 1.68219 14.1056 1.29141 13.7153C0.900637 13.3251 0.900224 12.6919 1.29049 12.3011L13.2827 0.29334C13.6729 -0.0974357 14.3061 -0.0978523 14.6969 0.29241L26.7047 12.2844C27.0955 12.6746 27.0959 13.3078 26.7056 13.6986C26.3154 14.0894 25.6822 14.0898 25.2914 13.6995L14.9918 3.41355Z"
      }
    ),
    /* @__PURE__ */ jsx5("path", { d: "M15.0097 30.9993C15.0101 31.5516 14.5627 31.9996 14.0104 32C13.4581 32.0003 13.0101 31.5529 13.0097 31.0006C13.0094 30.4483 13.4568 30.0003 14.0091 30C14.5614 29.9996 15.0094 30.447 15.0097 30.9993Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/ArrowThick.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var ArrowThickIcon = (props) => {
  return /* @__PURE__ */ jsxs3(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 33 32", defaultLabel: getArrowLabel(props.direction) }, props), { children: [
    /* @__PURE__ */ jsx6(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.3474 31.2836C17.609 31.2836 17.821 31.0697 17.821 30.806L17.821 5.60841L26.7636 14.6249C27.3186 15.1844 28.2183 15.1844 28.7733 14.6249C29.3282 14.0653 29.3282 13.1581 28.7732 12.5985L17.4048 1.13607C16.8498 0.576526 15.9501 0.576535 15.3951 1.13609L4.02673 12.5988C3.47178 13.1583 3.47178 14.0656 4.02674 14.6251C4.58169 15.1847 5.48145 15.1847 6.03641 14.6251L14.9789 5.60839L14.9789 30.806C14.9789 30.9326 15.0288 31.0541 15.1177 31.1437C15.2065 31.2333 15.327 31.2836 15.4526 31.2836H17.3474Z"
      }
    ),
    /* @__PURE__ */ jsx6(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9024 1.64266C16.6249 1.36289 16.175 1.36289 15.8975 1.64267L4.52915 13.1054C4.25168 13.3851 4.25168 13.8387 4.52915 14.1185C4.80663 14.3983 5.25651 14.3983 5.53399 14.1185L14.4765 5.10181C14.6797 4.89691 14.9853 4.83562 15.2508 4.94651C15.5164 5.05739 15.6895 5.31863 15.6895 5.60839L15.6895 30.5672H17.1105L17.1105 5.60841C17.1105 5.31864 17.2836 5.05741 17.5491 4.94652C17.8146 4.83563 18.1202 4.89693 18.3235 5.10182L27.266 14.1183C27.5435 14.3981 27.9934 14.3981 28.2708 14.1183C28.5483 13.8385 28.5483 13.3849 28.2708 13.1051L16.9024 1.64266ZM14.8927 0.629506C15.7251 -0.209824 17.0747 -0.209838 17.9072 0.629482L29.2757 12.0919C30.1081 12.9313 30.1081 14.2921 29.2757 15.1314C28.4433 15.9708 27.0936 15.9708 26.2612 15.1315L18.5316 7.33796L18.5316 30.806C18.5316 31.4654 18.0014 32 17.3474 32H15.4526C15.1386 32 14.8373 31.8742 14.6153 31.6503C14.3932 31.4263 14.2684 31.1226 14.2684 30.806L14.2684 7.33798L6.53883 15.1317C5.7064 15.971 4.35675 15.971 3.52432 15.1317C2.69189 14.2924 2.69188 12.9315 3.52432 12.0922L14.8927 0.629506Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Building.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var BuildingIcon = (props) => {
  return /* @__PURE__ */ jsxs4(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Bygning" }, props), { children: [
    /* @__PURE__ */ jsx7(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.1818 14.3156L15.1667 1.63745C15.1665 0.914419 14.6465 0.307158 13.9373 0.190459L13.9051 0.18515H3.78043C3.38 0.185155 2.95308 0.245588 2.63015 0.519566C2.29291 0.7995 2.11022 1.21302 2.11022 1.63756L2.1102 14.2156C1.83897 14.3586 1.6554 14.6431 1.6554 14.973C1.6554 15.4477 2.03565 15.8285 2.5102 15.8285H14.6327C15.1073 15.8285 15.4875 15.4477 15.4875 14.973C15.4875 14.7079 15.369 14.4722 15.1818 14.3156ZM6.20184 14.0942V11.3064C6.20184 10.4957 6.85667 9.83992 7.66689 9.83992H7.66789C7.66789 9.83992 9.53048 9.83992 9.77504 9.84521C10.5833 9.86268 11.2414 10.498 11.2414 11.3064V14.096L13.4719 14.0968L13.4574 1.88035L3.81983 1.88463V14.1104L6.20184 14.0942ZM9.77504 11.1564L8.67476 11.1536L7.66689 11.1511C7.57844 11.1511 7.51146 11.2185 7.51146 11.3064L7.51146 12.5369L7.51147 14.0947L9.93049 14.0956L9.93048 11.3117C9.93048 11.2257 9.85935 11.1564 9.77504 11.1564Z"
      }
    ),
    /* @__PURE__ */ jsx7(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7633 4.94316C10.7633 4.55161 10.4504 4.2377 10.0582 4.2377L7.29345 4.23772C6.90125 4.23772 6.58833 4.55162 6.58833 4.94317C6.58833 5.33472 6.90125 5.64863 7.29345 5.64863L10.0582 5.64862C10.4504 5.64862 10.7633 5.33471 10.7633 4.94316ZM10.7633 7.77476C10.7633 7.38321 10.4504 7.0693 10.0582 7.0693L7.29345 7.06932C6.90124 7.06932 6.58833 7.38323 6.58833 7.77477C6.58833 8.16633 6.90125 8.48023 7.29345 8.48023L10.0582 8.48022C10.4504 8.48022 10.7633 8.16632 10.7633 7.77476Z"
      }
    ),
    /* @__PURE__ */ jsx7(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7633 4.94316C10.7633 4.55161 10.4504 4.2377 10.0582 4.2377L7.29345 4.23772C6.90125 4.23772 6.58833 4.55162 6.58833 4.94317C6.58833 5.33472 6.90125 5.64863 7.29345 5.64863L10.0582 5.64862C10.4504 5.64862 10.7633 5.33471 10.7633 4.94316ZM10.7633 7.77476C10.7633 7.38321 10.4504 7.0693 10.0582 7.0693L7.29345 7.06932C6.90124 7.06932 6.58833 7.38323 6.58833 7.77477C6.58833 8.16633 6.90125 8.48023 7.29345 8.48023L10.0582 8.48022C10.4504 8.48022 10.7633 8.16632 10.7633 7.77476Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/CheckmarkCircle.tsx
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var CheckmarkCircleIcon = (props) => {
  return /* @__PURE__ */ jsxs5(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Checkmark sirkel" }, props), { children: [
    /* @__PURE__ */ jsx8("circle", { cx: "8.57141", cy: "8", r: "7", strokeWidth: "2", fill: "none", stroke: "currentColor" }),
    /* @__PURE__ */ jsx8("path", { d: "M7.63476 10.9885C7.55839 11.0654 7.4542 11.1082 7.34598 11.1082C7.23775 11.1082 7.13356 11.0654 7.0572 10.9885L4.75092 8.6819C4.51158 8.44255 4.51158 8.05445 4.75092 7.81556L5.0397 7.5267C5.27911 7.28736 5.66677 7.28736 5.90611 7.5267L7.34598 8.96664L11.2367 5.07585C11.4761 4.83651 11.8641 4.83651 12.1031 5.07585L12.3919 5.36471C12.6312 5.60405 12.6312 5.99208 12.3919 6.23105L7.63476 10.9885Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Chevron.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var ChevronIcon = (props) => {
  return /* @__PURE__ */ jsx9(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 14 9", defaultLabel: getArrowLabel(props.direction) }, props), { children: /* @__PURE__ */ jsx9(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.260942 8.34203C-0.0869808 7.9941 -0.0869807 7.43001 0.26094 7.08209L6.37001 0.972998C6.71793 0.625079 7.28201 0.625074 7.62994 0.972989L13.7391 7.08195C14.087 7.42987 14.087 7.99396 13.7391 8.34189C13.3911 8.68981 12.8271 8.68982 12.4791 8.3419L6.99999 2.86289L1.52088 8.34202C1.17296 8.68995 0.608864 8.68995 0.260942 8.34203Z"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Circle.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var CircleIcon = (props) => {
  return /* @__PURE__ */ jsx10(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 13 13", defaultLabel: "Sirkel ikon" }, props), { children: /* @__PURE__ */ jsx10("circle", { cx: "6.40002", cy: "6.4176", r: "6" }) }));
};

// ../udir-lisa/src/components/Icon/icons/CircledInfo.tsx
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var CircledInfoIcon = (props) => {
  return /* @__PURE__ */ jsxs6(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Infosirkel" }, props), { children: [
    /* @__PURE__ */ jsx11("circle", { cx: "8.65723", cy: "8", r: "7", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
    /* @__PURE__ */ jsx11("rect", { x: "7.65723", y: "3.90547", width: "2", height: "2", rx: "1" }),
    /* @__PURE__ */ jsx11("rect", { x: "7.65723", y: "7", width: "2", height: "5.91367", rx: "1" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Exit.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var ExitIcon = (props) => {
  return /* @__PURE__ */ jsx12(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 13 14", defaultLabel: "Kryss" }, props), { children: /* @__PURE__ */ jsx12(
    "path",
    {
      d: "M10.8659 1.51997L6.80008 5.58576L2.7342 1.51987C2.34387 1.12954 1.71034 1.12959 1.31996 1.51997C0.929648 1.91028 0.929648 2.54381 1.31996 2.93412L5.38584 7L1.31996 11.0659C0.929648 11.4562 0.929648 12.0897 1.31996 12.48C1.71034 12.8704 2.34387 12.8705 2.7342 12.4801L6.80008 8.41424L10.8659 12.48C11.2563 12.8704 11.8898 12.8705 12.2801 12.4801C12.6705 12.0897 12.6705 11.4562 12.2801 11.0658L8.21432 7L12.2801 2.93421C12.6705 2.54381 12.6705 1.91028 12.2801 1.51987C11.8898 1.12954 11.2563 1.12959 10.8659 1.51997Z",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Filter.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var FilterIcon = (props) => {
  return /* @__PURE__ */ jsx13(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Filter" }, props), { children: /* @__PURE__ */ jsx13(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 1C2 0.447715 2.44772 0 3 0H14C14.5523 0 15 0.447716 15 1V3.14316C15 3.39903 14.9019 3.64517 14.7259 3.83092L10.424 8.37173V13.3662C10.424 13.7371 10.2187 14.0775 9.89075 14.2506L8.04275 15.2259C7.37679 15.5774 6.576 15.0945 6.576 14.3415V8.37173L2.27406 3.83092C2.09808 3.64517 2 3.39903 2 3.14316V1ZM3.56 1.60229V2.41504H13.44V1.60229H3.56ZM12.3727 4.01733H4.62734L8.136 7.72081V13.3753L8.864 12.991V7.72081L12.3727 4.01733Z"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/ClearFilter.tsx
import { jsx as jsx14, jsxs as jsxs7 } from "react/jsx-runtime";
var ClearFilterIcon = (props) => {
  return /* @__PURE__ */ jsxs7(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Nullstill filter" }, props), { children: [
    /* @__PURE__ */ jsx14(
      "path",
      {
        d: "M9.26402 12.991L8.53602 13.3753V10.548V8.56495L6.97602 10.229V14.3415C6.97602 15.0945 7.77682 15.5774 8.44277 15.2259L10.2908 14.2506C10.6188 14.0775 10.824 13.7371 10.824 13.3662V8.37173L15.126 3.83092C15.3019 3.64517 15.4 3.39903 15.4 3.14316V1.21484L12.7727 4.01733L9.26402 7.72081V12.991Z",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx14(
      "path",
      {
        d: "M3.96002 2.41504V1.60229H11.6199L13.1031 0H3.40002C2.84774 0 2.40002 0.447715 2.40002 1V3.14316C2.40002 3.39903 2.49811 3.64517 2.67408 3.83092L6.13243 7.48129L7.19385 6.30411L5.02736 4.01733H9.36658L10.8478 2.41504H3.96002Z",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx14(
      "path",
      {
        d: "M3.61655 13.065L15.826 0.00210571L13.7729 0.00210568L2.5207 12.0407L3.61655 13.065Z",
        fillRule: "evenodd"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Home.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var HomeIcon = (props) => {
  return /* @__PURE__ */ jsx15(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Hjem" }, props), { children: /* @__PURE__ */ jsx15(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7643 9.32999C16.4974 8.59667 16.4976 7.40476 15.7654 6.67101L9.64449 0.550282C9.28986 0.195544 8.81589 -0.000747681 8.31443 -0.000747681C7.81292 -0.000747681 7.33896 0.195587 6.98426 0.550288L0.867754 6.66667L0.857715 6.67686C0.131019 7.41114 0.133187 8.59866 0.864483 9.32995C1.15293 9.6185 1.52214 9.80251 1.92082 9.86062V13.8845C1.92082 15.0519 2.86989 16.0008 4.03723 16.0008H6.43135C6.95033 16.0008 7.37084 15.58 7.37084 15.0613V11.5306C7.37084 11.4002 7.47777 11.2932 7.60838 11.2932H9.02049C9.151 11.2932 9.25791 11.4001 9.25791 11.5306V15.0613C9.25791 15.58 9.67842 16.0008 10.1974 16.0008H12.5915C13.759 16.0008 14.7079 15.0519 14.7079 13.8845V9.86145C15.1062 9.80347 15.4749 9.6194 15.7643 9.32999ZM14.6149 7.99869L14.6128 7.99666L8.49502 1.87888L8.49365 1.87825L8.4925 1.87866L2.37262 7.99831L3.03953 8.00222C3.55843 8.00222 3.97903 8.42283 3.97903 8.94172V13.8845C3.97903 14.0148 4.08595 14.1218 4.21645 14.1218H5.67106V11.5306C5.67106 10.3632 6.62012 9.41422 7.78759 9.41422H9.19971C10.3672 9.41422 11.3161 10.3633 11.3161 11.5306V14.1218H12.7707C12.9013 14.1218 13.0082 14.0148 13.0082 13.8845V8.94172C13.0082 8.42283 13.4288 8.00222 13.9477 8.00222H14.6133L14.6148 8.00149L14.615 8.00005L14.6149 7.99869Z"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Link.tsx
import { jsx as jsx16, jsxs as jsxs8 } from "react/jsx-runtime";
var LinkIcon = (props) => {
  return /* @__PURE__ */ jsxs8(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Lenke" }, props), { children: [
    /* @__PURE__ */ jsx16(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 6.96226C0 4.92033 1.59704 3.26501 3.5671 3.26501H6.25451V5.14594H3.5671C2.59929 5.14594 1.81472 5.95914 1.81472 6.96226V9.03776C1.81472 10.0409 2.59929 10.8541 3.5671 10.8541H6.25451V12.735H3.5671C1.59705 12.735 0 11.0797 0 9.03776V6.96226ZM9.7455 3.26502H12.4329C14.403 3.26502 16 4.92033 16 6.96227V9.03777C16 11.0797 14.403 12.735 12.4329 12.735H9.7455V10.8541H12.4329C13.4007 10.8541 14.1853 10.0409 14.1853 9.03777V6.96227C14.1853 5.95914 13.4007 5.14595 12.4329 5.14595H9.7455V3.26502Z"
      }
    ),
    /* @__PURE__ */ jsx16("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2799 8.90038H3.71997V6.98999H12.2799V8.90038Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/LinkBroken.tsx
import { jsx as jsx17, jsxs as jsxs9 } from "react/jsx-runtime";
var LinkBrokenIcon = (props) => {
  return /* @__PURE__ */ jsxs9(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "\xD8delagt lenke" }, props), { children: [
    /* @__PURE__ */ jsx17("path", { d: "M6.57578 6.99457H4.40576V8.7257L6.57578 6.99457Z" }),
    /* @__PURE__ */ jsx17("path", { d: "M12.9657 9.00539V6.99457H11.552L9.01576 9.00539H12.9657Z" }),
    /* @__PURE__ */ jsx17(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.9795 3.12587C14.2319 3.47152 14.1668 3.97 13.8341 4.23925L2.99217 13.0125C2.65943 13.2817 2.18503 13.2198 1.93258 12.8741C1.68012 12.5285 1.7452 12.03 2.07794 11.7608L12.9199 2.98753C13.2526 2.71828 13.727 2.78022 13.9795 3.12587Z"
      }
    ),
    /* @__PURE__ */ jsx17("path", { d: "M4.25289 3.50986C2.28284 3.50986 0.685791 5.16572 0.685791 7.20834V9.28454C0.685791 10.101 0.940979 10.8557 1.37317 11.4676L2.80367 10.3063C2.61235 10.0152 2.50051 9.66341 2.50051 9.28454V7.20834C2.50051 6.20488 3.28508 5.39141 4.25289 5.39141H6.9403V3.50986H4.25289Z" }),
    /* @__PURE__ */ jsx17("path", { d: "M6.9403 12.983V11.1015H6.77473L4.43151 12.983H6.9403Z" }),
    /* @__PURE__ */ jsx17("path", { d: "M16.6858 9.28454V7.20834C16.6858 5.99851 16.1255 4.92436 15.2593 4.24959L13.6802 5.4867C14.3726 5.72938 14.8711 6.40851 14.8711 7.20834V9.28454C14.8711 10.288 14.0865 11.1015 13.1187 11.1015H10.4313V12.983H13.1187C15.0887 12.983 16.6858 11.3272 16.6858 9.28454Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Locked.tsx
import { jsx as jsx18, jsxs as jsxs10 } from "react/jsx-runtime";
var LockedIcon = (props) => {
  return /* @__PURE__ */ jsxs10(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "L\xE5st" }, props), { children: [
    /* @__PURE__ */ jsx18("circle", { cx: "8.65731", cy: "10.2955", r: "1.19551" }),
    /* @__PURE__ */ jsx18("path", { d: "M8.00256 11.1892H9.312V12.1379C9.312 12.4995 9.01887 12.7926 8.65728 12.7926V12.7926C8.29569 12.7926 8.00256 12.4995 8.00256 12.1379V11.1892Z" }),
    /* @__PURE__ */ jsx18(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.83936 10.0399C2.83936 7.65939 4.76916 5.72958 7.14969 5.72958L10.1649 5.7296C12.5455 5.7296 14.4753 7.65939 14.4753 10.0399V11.6897C14.4753 14.0702 12.5455 16 10.1649 16H7.14969C4.76916 16 2.83936 14.0702 2.83936 11.6897V10.0399ZM7.14969 7.45372C5.72137 7.45372 4.56349 8.6116 4.56349 10.0399V11.6897C4.56349 13.118 5.72137 14.2759 7.14969 14.2759L10.1649 14.2759C11.5932 14.2759 12.7511 13.118 12.7511 11.6897V10.0399C12.7511 8.61161 11.5932 7.45373 10.1649 7.45373L7.14969 7.45372Z"
      }
    ),
    /* @__PURE__ */ jsx18(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.71385 2.47145C7.65357 2.47145 7.23756 3.32353 7.23756 4.3838V6.52819H5.51343V4.3838C5.51343 2.37131 6.70136 0.747315 8.71385 0.747315C10.7263 0.747315 11.8013 2.37131 11.8013 4.3838V6.52819H10.0772V4.3838C10.0772 3.32353 9.77412 2.47145 8.71385 2.47145Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Mail.tsx
import { jsx as jsx19, jsxs as jsxs11 } from "react/jsx-runtime";
var MailIcon = (props) => {
  return /* @__PURE__ */ jsxs11(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 14", defaultLabel: "Mail" }, props), { children: [
    /* @__PURE__ */ jsx19(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6572 2.59671H2.65723V11.4033L14.6572 11.4033V2.59671ZM14.6572 0.5H2.65723C1.55266 0.5 0.657227 1.43873 0.657227 2.59671V11.4033C0.657227 12.5613 1.55266 13.5 2.65723 13.5H14.6572C15.7618 13.5 16.6572 12.5613 16.6572 11.4033V2.59671C16.6572 1.43873 15.7618 0.5 14.6572 0.5Z"
      }
    ),
    /* @__PURE__ */ jsx19(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.76599 1.11877L8.67199 5.86975L14.5468 1.12289L15.7677 2.78358L9.89291 7.53045C9.17468 8.11078 8.17388 8.11191 7.45446 7.53319L1.54846 2.78221L2.76599 1.11877Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Redo.tsx
import { jsx as jsx20, jsxs as jsxs12 } from "react/jsx-runtime";
var RedoIcon = (props) => {
  return /* @__PURE__ */ jsxs12(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Last inn p\xE5 nytt" }, props), { children: [
    /* @__PURE__ */ jsx20("path", { d: "M7.99907 12.9989C6.86612 12.9986 5.67043 12.6971 4.86557 11.8935L4.00003 13.7343C6.76431 15.6778 10.6082 15.3772 13.0328 12.8728C14.2977 11.5662 15.0034 9.818 15.0001 7.99948C14.9999 7.44735 14.5522 6.99995 14.0001 6.99995C13.495 6.99995 13.0001 7.46481 13.0096 7.97945C13.0098 7.98828 13.0001 7.99996 13.0001 7.99996C12.9995 10.7613 10.7605 12.9994 7.99907 12.9989Z" }),
    /* @__PURE__ */ jsx20("path", { d: "M4.00003 13.7343L4.86557 11.8935C4.86557 11.8935 2.99619 10.6863 2.99619 7.5273C2.99619 6.54376 0.967592 6.77919 1.00002 7.52734C1.18129 11.7096 4.00003 13.7343 4.00003 13.7343Z" }),
    /* @__PURE__ */ jsx20(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.05067 5.31682C9.2251 5.84109 9.79152 6.12487 10.3159 5.9504C10.3159 5.9504 13.2243 4.98825 13.3161 4.95036C14.0001 4.66788 14.0001 4.67942 14.0001 3.99935V0.999998C14.0001 0.447701 13.5524 -1.14441e-05 13.0001 -1.14441e-05C12.4478 -1.14441e-05 12.0001 0.447701 12.0001 0.999998V1.76569C9.23581 -0.17787 5.39195 0.122776 2.96732 2.6272C1.70239 3.93373 0.996675 5.68196 1.00005 7.50047C1.00025 8.0526 1.44793 8.5 2.00001 8.5C2.50508 8.5 3.00002 8.03514 2.99049 7.5205C2.99033 7.51167 3.00002 7.49999 3.00002 7.49999C3.00063 4.73863 5.23963 2.50054 8.00105 2.5011C9.134 2.50131 10.2248 2.88591 11.1014 3.57908L9.68395 4.05165C9.15987 4.22619 8.87622 4.79249 9.05067 5.31682Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Stopwatch.tsx
import { jsx as jsx21, jsxs as jsxs13 } from "react/jsx-runtime";
var StopwatchIcon = (props) => {
  return /* @__PURE__ */ jsxs13(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 17", defaultLabel: "Stoppeklokke" }, props), { children: [
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.96401 15C10.6743 15 12.8462 12.8229 12.8462 10.1684C12.8462 7.51384 10.6743 5.33676 7.96401 5.33676C5.25369 5.33676 3.08179 7.51384 3.08179 10.1684C3.08179 12.8229 5.25369 15 7.96401 15ZM14.8462 10.1684C14.8462 13.9414 11.765 17 7.96401 17C4.16306 17 1.08179 13.9414 1.08179 10.1684C1.08179 6.39539 4.16306 3.33676 7.96401 3.33676C11.765 3.33676 14.8462 6.39539 14.8462 10.1684Z"
      }
    ),
    /* @__PURE__ */ jsx21("path", { d: "M8.85653 2.62805H7.24756V3.62755H8.85653V2.62805Z" }),
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.22754 2.60806H8.87651V3.64756H7.22754V2.60806ZM7.26754 2.64806V3.60756H8.83651V2.64806H7.26754Z"
      }
    ),
    /* @__PURE__ */ jsx21("path", { d: "M9.98819 1H5.93982V2.62805H9.98819V1Z" }),
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.9198 0.980011H10.0082V2.64806H5.9198V0.980011ZM5.9598 1.02001V2.60806H9.96817V1.02001H5.9598Z"
      }
    ),
    /* @__PURE__ */ jsx21(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.0471 5.2553C13.3958 4.4678 12.5911 3.81805 11.6807 3.34514L12.5778 1.61792C13.7191 2.21073 14.7289 3.02578 15.547 4.01488L14.0471 5.2553Z"
      }
    ),
    /* @__PURE__ */ jsx21("path", { d: "M7.89389 8.35741C7.89389 10.4442 7.89389 10.2933 7.89389 10.2933C5.80711 10.2933 3.99707 10.2933 3.99707 10.2933C3.99707 8.20652 5.80711 6.21207 7.89389 6.21207C7.89389 6.21207 7.89389 6.27063 7.89389 8.35741Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Trash.tsx
import { jsx as jsx22, jsxs as jsxs14 } from "react/jsx-runtime";
var TrashIcon = (props) => {
  return /* @__PURE__ */ jsxs14(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "S\xF8ppelb\xF8tte" }, props), { children: [
    /* @__PURE__ */ jsx22(
      "path",
      {
        d: "M13.358 6.19238V5.62335H14.3642C14.5882 5.62335 14.7799 5.49889 14.9112 5.33578C15.0425 5.17249 15.125 4.95717 15.125 4.74587C15.125 4.53441 15.0424 4.32052 14.9107 4.15871C14.7791 3.99699 14.5874 3.875 14.3642 3.875H1.63585C1.41201 3.875 1.2203 3.9988 1.08896 4.16154C0.957494 4.32443 0.875 4.53936 0.875 4.75071C0.875 4.96213 0.957548 5.1764 1.08917 5.33861C1.22069 5.5007 1.41239 5.62335 1.63585 5.62335H2.86382V6.19235V6.19238L2.86243 14.0581V14.0582C2.86243 14.6158 3.06134 15.1432 3.41382 15.5241L3.50557 15.4393L3.4135 15.5238C3.51077 15.6297 3.64909 15.7176 3.80088 15.7902C3.9541 15.8634 4.12875 15.9246 4.30568 15.9737C4.65826 16.0715 5.0324 16.1246 5.28467 16.125H5.28489H11.4513H11.4516C11.9649 16.1241 12.4544 15.9063 12.8055 15.5239C13.1578 15.143 13.3567 14.6157 13.3567 14.0582C13.3567 14.0582 13.3567 14.0582 13.3567 14.0582L13.358 6.1924V6.19238ZM11.7591 13.5784V13.5784C11.7591 13.7811 11.6593 13.9934 11.4999 14.1572C11.3403 14.3211 11.1351 14.4221 10.9413 14.4221H5.75626C4.84994 14.4221 4.46717 13.9697 4.46715 13.5784C4.46715 13.5784 4.46715 13.5784 4.46715 13.5784L4.46852 5.62335H11.7604L11.7591 13.5784Z",
        strokeWidth: "0.25"
      }
    ),
    /* @__PURE__ */ jsx22("path", { d: "M5 1.25C5 0.835786 5.33579 0.5 5.75 0.5H10.25C10.6642 0.5 11 0.835786 11 1.25C11 1.66421 10.6642 2 10.25 2H5.75C5.33579 2 5 1.66421 5 1.25Z" }),
    /* @__PURE__ */ jsx22("path", { d: "M6.51331 7C6.92752 7 7.26331 7.33579 7.26331 7.75L7.26331 12.25C7.26331 12.6642 6.92752 13 6.51331 13C6.09909 13 5.76331 12.6642 5.76331 12.25L5.76331 7.75C5.76331 7.33579 6.09909 7 6.51331 7Z" }),
    /* @__PURE__ */ jsx22("path", { d: "M9.48657 7C9.90079 7 10.2366 7.33579 10.2366 7.75L10.2366 12.25C10.2366 12.6642 9.90079 13 9.48657 13C9.07236 13 8.73657 12.6642 8.73657 12.25L8.73657 7.75C8.73657 7.33579 9.07236 7 9.48657 7Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/UdirArrow.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var UdirArrowIcon = (props) => {
  return /* @__PURE__ */ jsx23(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 33", defaultLabel: getArrowLabel(props.direction), $size: 32 }, props), { children: /* @__PURE__ */ jsx23(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 11.3149H9L9 32.3149H7L7 11.3149H0L8 0.314941L16 11.3149ZM4 9.31494L8 3.64494L12 9.31494L4 9.31494Z"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Unlocked.tsx
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var UnlockedIcon = (props) => {
  return /* @__PURE__ */ jsxs15(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Ul\xE5st" }, props), { children: [
    /* @__PURE__ */ jsx24("circle", { cx: "8.74288", cy: "10.2955", r: "1.19551" }),
    /* @__PURE__ */ jsx24("path", { d: "M8.08813 11.1892H9.39757V12.1379C9.39757 12.4995 9.10445 12.7926 8.74285 12.7926V12.7926C8.38126 12.7926 8.08813 12.4995 8.08813 12.1379V11.1892Z" }),
    /* @__PURE__ */ jsx24(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.9248 10.0399C2.9248 7.65939 4.8546 5.72958 7.23514 5.72958L10.2504 5.7296C12.6309 5.7296 14.5607 7.65939 14.5607 10.0399V11.6897C14.5607 14.0702 12.6309 16 10.2504 16H7.23514C4.85461 16 2.9248 14.0702 2.9248 11.6897V10.0399ZM7.23514 7.45372C5.80682 7.45372 4.64894 8.6116 4.64894 10.0399V11.6897C4.64894 13.118 5.80682 14.2759 7.23514 14.2759L10.2504 14.2759C11.6787 14.2759 12.8366 13.118 12.8366 11.6897V10.0399C12.8366 8.61161 11.6787 7.45373 10.2504 7.45373L7.23514 7.45372Z"
      }
    ),
    /* @__PURE__ */ jsx24("path", { d: "M3.21595 4.38649C3.21595 3.32621 3.63196 2.47413 4.69224 2.47413C5.75251 2.47413 6.05555 3.32621 6.05555 4.38649V6.53087H7.77968V4.38649C7.77968 2.374 6.70473 0.75 4.69224 0.75C2.67975 0.75 1.49182 2.374 1.49182 4.38649H3.21595Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Calendar.tsx
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var CalendarIcon = (props) => {
  return /* @__PURE__ */ jsxs16(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Kalender" }, props), { children: [
    /* @__PURE__ */ jsx25(
      "path",
      {
        d: "M15.75 4.03656C15.7541 3.04294 14.947 2.20363 13.9449 2.20363H13.2532V1.70735C13.2532 1.35438 12.9655 1.06662 12.6125 1.06662C12.2595 1.06662 11.9718 1.35438 11.9718 1.70735V2.20363H8.39267H7.61122H3.99303V1.70735C3.99303 1.35438 3.70527 1.06662 3.3523 1.06662C2.99933 1.06662 2.71158 1.35438 2.71158 1.70735V2.20363H2.059C1.05651 2.20363 0.25 3.04327 0.25 4.03608V13.1205C0.25 14.1212 1.05661 14.9334 2.059 14.9334H13.941C14.943 14.9334 15.75 14.1216 15.75 13.1244V4.03656ZM15.75 4.03656C15.75 4.03677 15.75 4.03699 15.75 4.03721L15.5 4.03608H15.75V4.03656ZM14.4724 13.1205C14.4724 13.413 14.2394 13.6487 13.9476 13.6519H13.9449H2.059C1.76727 13.6519 1.53145 13.4161 1.53145 13.1244V13.1205V4.03608C1.53145 3.73153 1.77602 3.48509 2.059 3.48509H2.71158V3.80164C2.71158 4.15461 2.99933 4.44237 3.3523 4.44237C3.70527 4.44237 3.99303 4.15461 3.99303 3.80164V3.48509H7.61122H8.39267H11.9718V3.80164C11.9718 4.15461 12.2595 4.44237 12.6125 4.44237C12.9655 4.44237 13.2532 4.15461 13.2532 3.80164V3.48509H13.9449C14.2302 3.48509 14.4724 3.73379 14.4724 4.03608V13.1205Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx25("path", { d: "M3.58203 11V10.1836H5.10156V6.70312C5 6.91667 4.79688 7.09635 4.49219 7.24219C4.1901 7.38802 3.8724 7.46094 3.53906 7.46094V6.625C3.90104 6.625 4.22526 6.54557 4.51172 6.38672C4.79818 6.22786 5.01432 6.00911 5.16016 5.73047H6.19922V10.1836H7.46094V11H3.58203ZM8.38672 11V10.1836H9.90625V6.70312C9.80469 6.91667 9.60156 7.09635 9.29688 7.24219C8.99479 7.38802 8.67708 7.46094 8.34375 7.46094V6.625C8.70573 6.625 9.02995 6.54557 9.31641 6.38672C9.60286 6.22786 9.81901 6.00911 9.96484 5.73047H11.0039V10.1836H12.2656V11H8.38672Z" }),
    /* @__PURE__ */ jsx25("path", { d: "M3.58203 11H3.28203V11.3H3.58203V11ZM3.58203 10.1836V9.88359H3.28203V10.1836H3.58203ZM5.10156 10.1836V10.4836H5.40156V10.1836H5.10156ZM5.10156 6.70312H5.40156L4.83064 6.57427L5.10156 6.70312ZM4.49219 7.24219L4.36267 6.97158L4.36176 6.97202L4.49219 7.24219ZM3.53906 7.46094H3.23906V7.76094H3.53906V7.46094ZM3.53906 6.625V6.325H3.23906V6.625H3.53906ZM5.16016 5.73047V5.43047H4.97856L4.89436 5.59136L5.16016 5.73047ZM6.19922 5.73047H6.49922V5.43047H6.19922V5.73047ZM6.19922 10.1836H5.89922V10.4836H6.19922V10.1836ZM7.46094 10.1836H7.76094V9.88359H7.46094V10.1836ZM7.46094 11V11.3H7.76094V11H7.46094ZM3.88203 11V10.1836H3.28203V11H3.88203ZM3.58203 10.4836H5.10156V9.88359H3.58203V10.4836ZM5.40156 10.1836V6.70312H4.80156V10.1836H5.40156ZM4.83064 6.57427C4.76895 6.70398 4.63134 6.84299 4.36267 6.97159L4.62171 7.51279C4.96241 7.34972 5.23105 7.12935 5.37248 6.83198L4.83064 6.57427ZM4.36176 6.97202C4.10009 7.09835 3.82693 7.16094 3.53906 7.16094V7.76094C3.91786 7.76094 4.28012 7.67769 4.62261 7.51235L4.36176 6.97202ZM3.83906 7.46094V6.625H3.23906V7.46094H3.83906ZM3.53906 6.925C3.94648 6.925 4.32168 6.83514 4.65721 6.64908L4.36623 6.12436C4.12884 6.256 3.85561 6.325 3.53906 6.325V6.925ZM4.65721 6.64908C4.99271 6.46303 5.25176 6.20241 5.42595 5.86958L4.89436 5.59136C4.77689 5.81581 4.60365 5.9927 4.36623 6.12436L4.65721 6.64908ZM5.16016 6.03047H6.19922V5.43047H5.16016V6.03047ZM5.89922 5.73047V10.1836H6.49922V5.73047H5.89922ZM6.19922 10.4836H7.46094V9.88359H6.19922V10.4836ZM7.16094 10.1836V11H7.76094V10.1836H7.16094ZM7.46094 10.7H3.58203V11.3H7.46094V10.7ZM8.38672 11H8.08672V11.3H8.38672V11ZM8.38672 10.1836V9.88359H8.08672V10.1836H8.38672ZM9.90625 10.1836V10.4836H10.2063V10.1836H9.90625ZM9.90625 6.70312H10.2063L9.63533 6.57427L9.90625 6.70312ZM9.29688 7.24219L9.16736 6.97158L9.16645 6.97202L9.29688 7.24219ZM8.34375 7.46094H8.04375V7.76094H8.34375V7.46094ZM8.34375 6.625V6.325H8.04375V6.625H8.34375ZM9.96484 5.73047V5.43047H9.78325L9.69905 5.59136L9.96484 5.73047ZM11.0039 5.73047H11.3039V5.43047H11.0039V5.73047ZM11.0039 10.1836H10.7039V10.4836H11.0039V10.1836ZM12.2656 10.1836H12.5656V9.88359H12.2656V10.1836ZM12.2656 11V11.3H12.5656V11H12.2656ZM8.68672 11V10.1836H8.08672V11H8.68672ZM8.38672 10.4836H9.90625V9.88359H8.38672V10.4836ZM10.2063 10.1836V6.70312H9.60625V10.1836H10.2063ZM9.63533 6.57427C9.57364 6.70398 9.43603 6.84299 9.16736 6.97159L9.42639 7.51279C9.76709 7.34972 10.0357 7.12935 10.1772 6.83198L9.63533 6.57427ZM9.16645 6.97202C8.90477 7.09835 8.63162 7.16094 8.34375 7.16094V7.76094C8.72255 7.76094 9.08481 7.67769 9.4273 7.51235L9.16645 6.97202ZM8.64375 7.46094V6.625H8.04375V7.46094H8.64375ZM8.34375 6.925C8.75116 6.925 9.12637 6.83514 9.4619 6.64908L9.17092 6.12436C8.93353 6.256 8.66029 6.325 8.34375 6.325V6.925ZM9.4619 6.64908C9.79739 6.46303 10.0564 6.20241 10.2306 5.86958L9.69905 5.59136C9.58157 5.81581 9.40833 5.9927 9.17092 6.12436L9.4619 6.64908ZM9.96484 6.03047H11.0039V5.43047H9.96484V6.03047ZM10.7039 5.73047V10.1836H11.3039V5.73047H10.7039ZM11.0039 10.4836H12.2656V9.88359H11.0039V10.4836ZM11.9656 10.1836V11H12.5656V10.1836H11.9656ZM12.2656 10.7H8.38672V11.3H12.2656V10.7Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Checkmark.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var CheckmarkIcon = (props) => {
  return /* @__PURE__ */ jsx26(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 12", defaultLabel: "Hake" }, props), { children: /* @__PURE__ */ jsx26("path", { d: "M15.5531 0.5617C15.1393 0.119468 14.4401 0.112021 14.017 0.545339L6.15313 8.96229L2.60946 5.1694C2.18646 4.73618 1.48738 4.74387 1.07402 5.1863L1.0221 5.24188C0.621337 5.67083 0.614053 6.33468 1.00531 6.77232L1.05741 6.8306L5.37765 11.4547C5.8035 11.8908 6.50493 11.8908 6.93077 11.4547L15.5713 2.20653L15.6224 2.14935C16.0141 1.71117 16.0066 1.04643 15.605 0.617239L15.5531 0.5617Z" }) }));
};

// ../udir-lisa/src/components/Icon/icons/Document.tsx
import { jsx as jsx27, jsxs as jsxs17 } from "react/jsx-runtime";
var DocumentIcon = (props) => {
  return /* @__PURE__ */ jsxs17(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 14 16", defaultLabel: "Dokument" }, props), { children: [
    /* @__PURE__ */ jsx27(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4391 16C12.5596 16.0044 13.4928 15.0805 13.4928 13.9449L13.4928 3.85215L9.64745 -1.08481e-07L2.52634 -4.79359e-07C1.39564 -5.28784e-07 0.492798 0.926686 0.492798 2.059L0.492797 13.941C0.492797 15.0725 1.39483 16 2.52251 16L11.4391 16ZM2.25957 13.9461C2.2619 14.1088 2.38766 14.2224 2.52634 14.2224L11.4401 14.2224C11.5977 14.2224 11.726 14.0906 11.726 13.9449L11.726 4.26655L9.23342 1.78145L2.52251 1.78145C2.38582 1.78145 2.25957 1.89636 2.25957 2.059L2.25957 13.9461Z"
      }
    ),
    /* @__PURE__ */ jsx27(
      "path",
      {
        d: "M3.88095 8.60821L10.1048 8.60822C10.3233 8.60822 10.4762 8.54293 10.5553 8.39538C10.5906 8.32964 10.6052 8.2574 10.6121 8.18991C10.6188 8.12381 10.6188 8.05285 10.6188 7.98665L10.6188 7.98308L10.6188 7.9796C10.6188 7.91337 10.6188 7.84238 10.6121 7.77625C10.6052 7.70876 10.5906 7.63652 10.5553 7.57078C10.4762 7.42325 10.3233 7.35796 10.1048 7.35796L3.88095 7.35796C3.66244 7.35796 3.50957 7.42325 3.43043 7.57078C3.39517 7.63652 3.38054 7.70876 3.37368 7.77625C3.36696 7.84238 3.36696 7.91337 3.36696 7.97959L3.36696 7.98308L3.36696 7.98657C3.36696 8.05279 3.36696 8.12379 3.37368 8.18992C3.38054 8.25741 3.39517 8.32964 3.43043 8.39539C3.50957 8.54292 3.66244 8.60821 3.88095 8.60821Z",
        stroke: "currentColor",
        strokeWidth: "0.25"
      }
    ),
    /* @__PURE__ */ jsx27(
      "path",
      {
        d: "M3.88095 12.1112L10.1048 12.1112C10.3233 12.1112 10.4762 12.0459 10.5553 11.8984C10.5906 11.8327 10.6052 11.7604 10.6121 11.6929C10.6188 11.6268 10.6188 11.5559 10.6188 11.4897L10.6188 11.4861L10.6188 11.4826C10.6188 11.4164 10.6188 11.3454 10.6121 11.2793C10.6052 11.2118 10.5906 11.1395 10.5553 11.0738C10.4762 10.9263 10.3233 10.861 10.1048 10.861L3.88095 10.861C3.66244 10.861 3.50957 10.9263 3.43043 11.0738C3.39517 11.1395 3.38054 11.2118 3.37368 11.2793C3.36696 11.3454 3.36696 11.4164 3.36696 11.4826L3.36696 11.4861L3.36696 11.4896C3.36696 11.5558 3.36696 11.6268 3.37368 11.6929C3.38054 11.7604 3.39517 11.8327 3.43043 11.8984C3.50957 12.0459 3.66244 12.1112 3.88095 12.1112Z",
        stroke: "currentColor",
        strokeWidth: "0.25"
      }
    ),
    /* @__PURE__ */ jsx27(
      "path",
      {
        d: "M3.71416 5.13901L7.27064 5.13901C7.34815 5.13901 7.4197 5.11891 7.47798 5.07156C7.5348 5.02539 7.56631 4.96358 7.58466 4.90372C7.61801 4.79489 7.61797 4.65397 7.61792 4.5273C7.61792 4.5228 7.61792 4.51833 7.61792 4.51388C7.61792 4.50944 7.61792 4.50499 7.61792 4.50052C7.61796 4.37383 7.61801 4.23288 7.58465 4.12403C7.5663 4.06417 7.53478 4.00236 7.47797 3.9562C7.41969 3.90885 7.34815 3.88875 7.27064 3.88875L3.71416 3.88875C3.63665 3.88875 3.56511 3.90885 3.50683 3.9562C3.45002 4.00236 3.4185 4.06417 3.40016 4.12403C3.36679 4.23288 3.36684 4.37382 3.36688 4.50052C3.36688 4.50499 3.36688 4.50944 3.36688 4.51388C3.36688 4.51831 3.36688 4.52276 3.36688 4.52723C3.36684 4.65393 3.36679 4.79487 3.40016 4.90372C3.4185 4.96359 3.45002 5.02539 3.50683 5.07156C3.56511 5.11891 3.63665 5.13901 3.71416 5.13901Z",
        stroke: "currentColor",
        strokeWidth: "0.25"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Download.tsx
import { jsx as jsx28, jsxs as jsxs18 } from "react/jsx-runtime";
var DownloadIcon = (props) => {
  return /* @__PURE__ */ jsxs18(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Nedlastingsikon" }, props), { children: [
    /* @__PURE__ */ jsx28(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.502 6.57712L7.99997 13.5781L3.49792 6.57712L12.502 6.57712ZM7.36353 0.421875L7.36353 6.42188H8.63643V0.421875H7.36353ZM10.251 7.84985L7.99997 11.4585L5.74895 7.84985H10.251Z"
      }
    ),
    /* @__PURE__ */ jsx28("path", { d: "M7.99997 13.5781L7.7897 13.7133L7.99997 14.0403L8.21025 13.7133L7.99997 13.5781ZM12.502 6.57712L12.7123 6.71234L12.96 6.32712H12.502V6.57712ZM3.49792 6.57712V6.32712H3.03993L3.28765 6.71234L3.49792 6.57712ZM7.36353 6.42188H7.11353V6.67188H7.36353V6.42188ZM7.36353 0.421875V0.171875H7.11353V0.421875H7.36353ZM8.63643 6.42188V6.67188H8.88643V6.42188H8.63643ZM8.63643 0.421875H8.88643V0.171875H8.63643V0.421875ZM7.99997 11.4585L7.78786 11.5909L7.99997 11.9309L8.21209 11.5909L7.99997 11.4585ZM10.251 7.84985L10.4631 7.98216L10.7016 7.59985H10.251V7.84985ZM5.74895 7.84985V7.59985H5.29835L5.53683 7.98216L5.74895 7.84985ZM8.21025 13.7133L12.7123 6.71234L12.2917 6.4419L7.7897 13.4429L8.21025 13.7133ZM3.28765 6.71234L7.7897 13.7133L8.21025 13.4429L3.7082 6.4419L3.28765 6.71234ZM12.502 6.32712L3.49792 6.32712V6.82712L12.502 6.82712V6.32712ZM7.61353 6.42188L7.61353 0.421875H7.11353L7.11353 6.42188H7.61353ZM8.63643 6.17188H7.36353V6.67188H8.63643V6.17188ZM8.38643 0.421875V6.42188H8.88643V0.421875H8.38643ZM7.36353 0.671875H8.63643V0.171875H7.36353V0.671875ZM8.21209 11.5909L10.4631 7.98216L10.0389 7.71754L7.78786 11.3262L8.21209 11.5909ZM5.53683 7.98216L7.78786 11.5909L8.21209 11.3262L5.96106 7.71754L5.53683 7.98216ZM10.251 7.59985H5.74895V8.09985H10.251V7.59985Z" }),
    /* @__PURE__ */ jsx28("line", { x1: "3.05286", y1: "14.3803", x2: "12.9472", y2: "14.3803", strokeWidth: "1.5", stroke: "currentColor" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Edit.tsx
import { jsx as jsx29, jsxs as jsxs19 } from "react/jsx-runtime";
var EditIcon = (props) => {
  return /* @__PURE__ */ jsxs19(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 17", defaultLabel: "Rediger" }, props), { children: [
    /* @__PURE__ */ jsx29(
      "path",
      {
        d: "M3.30675 0.750007L3.30646 0.750008C2.06755 0.751418 1.06573 1.76011 1.06433 3.0022V3.00249L1.06433 13.5L1.06433 13.5003C1.06573 14.7424 2.06755 15.7511 3.30646 15.7525H3.30675L13.3143 15.7525H13.3146C14.5535 15.7511 15.5553 14.7424 15.5567 13.5003V13.5V6.06086C15.5567 5.70276 15.2676 5.41036 14.9083 5.41036C14.5489 5.41036 14.2598 5.70276 14.2598 6.06086V13.4995C14.2592 14.0263 13.835 14.4508 13.3141 14.4513L3.30698 14.4513C2.78615 14.4508 2.36197 14.0263 2.3613 13.4996C2.3613 13.4996 2.3613 13.4996 2.3613 13.4996V3.00278C2.3613 3.00275 2.3613 3.00271 2.3613 3.00268C2.36197 2.47626 2.78603 2.05172 3.30686 2.051H8.81433C9.17369 2.051 9.46281 1.7586 9.46281 1.4005C9.46281 1.04263 9.17375 0.750008 8.81433 0.750008L3.30675 0.750007Z",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx29("rect", { x: "14.3143", width: "2", height: "12.5352", rx: "1", transform: "rotate(43.029 14.3143 0)" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/ExternalLink.tsx
import { jsx as jsx30, jsxs as jsxs20 } from "react/jsx-runtime";
var ExternalLinkIcon = (props) => {
  return /* @__PURE__ */ jsxs20(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Ekstern lenke" }, props), { children: [
    /* @__PURE__ */ jsx30(
      "path",
      {
        d: "M15.4003 0.584076H11.0385C10.7055 0.584076 10.4355 0.854013 10.4355 1.18711C10.4355 1.52017 10.7055 1.79011 11.0385 1.79011H14.7973V5.54889C14.7973 5.88195 15.0673 6.15189 15.4003 6.15189C15.7334 6.15189 16.0034 5.88195 16.0034 5.54889V1.18711C16.0034 0.854013 15.7334 0.584076 15.4003 0.584076Z",
        stroke: "currentColor",
        strokeWidth: "0.3"
      }
    ),
    /* @__PURE__ */ jsx30(
      "path",
      {
        d: "M15.3947 1.1767C15.1592 0.941102 14.7776 0.941102 14.5421 1.1767L5.93902 9.7797C5.70343 10.0151 5.70343 10.397 5.93902 10.6324C6.05662 10.7501 6.21099 10.809 6.36537 10.809C6.51952 10.809 6.6739 10.7501 6.79171 10.6324L15.3947 2.02935C15.6303 1.79398 15.6303 1.41207 15.3947 1.1767Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx30(
      "path",
      {
        d: "M14.3307 7.24956C13.8307 7.24956 13.8307 7.85006 13.8307 7.85006V14.7496L1.83069 14.7496V2.74956H8.58069C8.91375 2.74956 9.33069 2.74956 9.33069 2.24956C9.33069 1.74956 8.91375 1.79981 8.58069 1.79981H1.83069C1.33069 1.79981 0.830688 2.24956 0.830688 2.74956V14.7496C0.830688 15.2496 1.33069 15.7496 1.83069 15.7496H13.8307C14.3307 15.7496 14.7804 15.2496 14.7804 14.7496V7.85006C14.7804 7.85006 14.8307 7.24956 14.3307 7.24956Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Eye.tsx
import { jsx as jsx31, jsxs as jsxs21 } from "react/jsx-runtime";
var EyeIcon = (props) => {
  return /* @__PURE__ */ jsxs21(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "\xD8ye" }, props), { children: [
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M8.68579 5.79933C7.47236 5.79933 6.48511 6.78658 6.48511 8.00001C6.48511 9.21344 7.47236 10.2007 8.68579 10.2007C9.89922 10.2007 10.8865 9.21344 10.8865 8.00001C10.8865 6.78658 9.89922 5.79933 8.68579 5.79933ZM8.68579 9.46712C7.87679 9.46712 7.21868 8.80899 7.21868 8.00001C7.21868 7.19104 7.87681 6.53291 8.68579 6.53291C9.49476 6.53291 10.1529 7.19104 10.1529 8.00001C10.1529 8.80899 9.49479 9.46712 8.68579 9.46712Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.96814 8.00001C5.96814 6.50108 7.18683 5.28239 8.68576 5.28239C10.1847 5.28239 11.4034 6.50108 11.4034 8.00001C11.4034 9.49895 10.1847 10.7176 8.68576 10.7176C7.18683 10.7176 5.96814 9.49895 5.96814 8.00001ZM7.73559 8.00001C7.73559 8.5235 8.16226 8.95018 8.68576 8.95018C9.20926 8.95018 9.63593 8.5235 9.63593 8.00001C9.63593 7.47654 9.20924 7.04985 8.68576 7.04985C8.16228 7.04985 7.73559 7.47654 7.73559 8.00001ZM6.48508 8.00001C6.48508 6.78658 7.47233 5.79933 8.68576 5.79933C9.89919 5.79933 10.8864 6.78658 10.8864 8.00001C10.8864 9.21345 9.89919 10.2007 8.68576 10.2007C7.47233 10.2007 6.48508 9.21345 6.48508 8.00001ZM7.21865 8.00001C7.21865 8.80899 7.87676 9.46712 8.68576 9.46712C9.49476 9.46712 10.1529 8.80899 10.1529 8.00001C10.1529 7.19104 9.49474 6.53291 8.68576 6.53291C7.87678 6.53291 7.21865 7.19104 7.21865 8.00001Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M16.0739 7.7089C15.9402 7.526 12.7545 3.2305 8.68575 3.2305C4.61702 3.2305 1.43117 7.526 1.29761 7.70873C1.17098 7.88225 1.17098 8.11759 1.29761 8.2911C1.43117 8.474 4.61702 12.7695 8.68575 12.7695C12.7545 12.7695 15.9402 8.47397 16.0739 8.29125C16.2007 8.11776 16.2007 7.88225 16.0739 7.7089ZM8.68575 11.7827C5.6887 11.7827 3.09294 8.93171 2.32453 7.99967C3.09194 7.06681 5.68227 4.21729 8.68575 4.21729C11.6827 4.21729 14.2782 7.0678 15.047 8.00034C14.2796 8.93317 11.6892 11.7827 8.68575 11.7827Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M1.53493 7.40369L0.880248 7.40369L0.880022 8.59584L1.53465 8.59587C1.39775 8.4269 1.31664 8.31719 1.29759 8.29111C1.17096 8.11759 1.17096 7.88225 1.29759 7.70873C1.31665 7.68266 1.39786 7.57283 1.53493 7.40369Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M15.8364 7.4037C15.9735 7.57292 16.0548 7.6828 16.0739 7.70891C16.2007 7.88225 16.2007 8.11777 16.0739 8.29125C16.0548 8.31734 15.9735 8.42724 15.8363 8.59649L16.4911 8.59652L16.4911 7.4037L15.8364 7.4037Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M12.3942 6.17453C12.9411 6.57954 13.4199 7.01478 13.8069 7.40369L15.8364 7.4037C15.0128 6.38732 12.1737 3.2305 8.68573 3.2305C5.19762 3.2305 2.35838 6.38753 1.53493 7.40369L3.56244 7.40369C3.94901 7.01464 4.42745 6.57919 4.97433 6.17403C6.05319 5.37473 7.34324 4.73423 8.68573 4.73423C10.0247 4.73423 11.3144 5.37479 12.3942 6.17453Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M8.68573 11.2658C7.34667 11.2658 6.05692 10.6251 4.97706 9.82531C4.43012 9.42021 3.95131 8.98489 3.56427 8.59596L1.53465 8.59587C2.35773 9.61177 5.19722 12.7695 8.68573 12.7695C12.1736 12.7695 15.0126 9.61285 15.8363 8.59649L13.8089 8.5964C13.4224 8.98542 12.944 9.42084 12.3971 9.82598C11.3183 10.6253 10.0282 11.2658 8.68573 11.2658Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M3.18588 5.00327C1.81817 6.13813 0.959538 7.29521 0.880248 7.40369L1.53493 7.40369C2.35838 6.38753 5.19762 3.2305 8.68573 3.2305C12.1737 3.2305 15.0128 6.38732 15.8364 7.4037L16.4911 7.4037C16.4111 7.29432 15.5527 6.1377 14.1855 5.0033C12.8271 3.87607 10.8975 2.71356 8.68573 2.71356C6.47393 2.71356 4.54437 3.87607 3.18588 5.00327Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M14.1855 10.9967C15.5533 9.86184 16.4119 8.70474 16.4911 8.59652L15.8363 8.59649C15.0126 9.61285 12.1736 12.7695 8.68573 12.7695C5.19722 12.7695 2.35773 9.61177 1.53465 8.59587L0.880022 8.59584C0.959454 8.70462 1.81818 9.86186 3.18588 10.9967C4.54436 12.1239 6.47393 13.2865 8.68573 13.2865C10.8975 13.2865 12.8271 12.1239 14.1855 10.9967Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M16.0739 8.29125C16.2007 8.11777 16.2007 7.88225 16.0739 7.70891C16.0548 7.6828 15.9735 7.57292 15.8364 7.4037L13.8069 7.40369C14.0239 7.62174 14.212 7.82522 14.3672 8.00066C14.2126 8.17579 14.0251 8.37884 13.8089 8.5964L15.8363 8.59649C15.9735 8.42724 16.0548 8.31734 16.0739 8.29125Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M1.29759 7.70873C1.17096 7.88225 1.17096 8.11759 1.29759 8.29111C1.31664 8.31719 1.39775 8.4269 1.53465 8.59587L3.56427 8.59596C3.3474 8.37803 3.15934 8.17467 3.00426 7.99934C3.15887 7.82423 3.34629 7.62121 3.56244 7.40369L1.53493 7.40369C1.39786 7.57283 1.31665 7.68266 1.29759 7.70873Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M0.880248 7.40369C0.621123 7.75876 0.620897 8.24077 0.880022 8.59584L0.880248 7.40369Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx31("path", { d: "M16.4911 8.59652C16.7506 8.24147 16.7508 7.75885 16.4911 7.4037L16.4911 8.59652Z", fill: "currentColor" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Monitor.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var MonitorIcon = (props) => {
  return /* @__PURE__ */ jsx32(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Datamaskin" }, props), { children: /* @__PURE__ */ jsx32(
    "path",
    {
      d: "M14.6211 1.03125H1.37891C0.756206 1.03125 0.25 1.53746 0.25 2.16016V10.8906C0.25 11.5133 0.756206 12.0195 1.37891 12.0195H7.31055V13.6875H3.3125C2.93173 13.6875 2.62305 13.9962 2.62305 14.377C2.62305 14.7577 2.93173 15.0664 3.3125 15.0664H12.6875C13.0683 15.0664 13.377 14.7577 13.377 14.377C13.377 13.9962 13.0683 13.6875 12.6875 13.6875H8.68945V12.0195H14.6211C15.2438 12.0195 15.75 11.5133 15.75 10.8906V2.16016C15.75 1.53746 15.2438 1.03125 14.6211 1.03125ZM14.3724 9.87049C14.3725 10.252 14.3726 10.491 14.3725 10.6406H1.62891V2.41016H14.3711C14.3714 6.29197 14.372 8.39778 14.3723 9.53977L14.3724 9.87049Z",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/MouseClick.tsx
import { jsx as jsx33, jsxs as jsxs22 } from "react/jsx-runtime";
var MouseClickIcon = (props) => {
  return /* @__PURE__ */ jsxs22(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Musepeker" }, props), { children: [
    /* @__PURE__ */ jsx33(
      "path",
      {
        fill: "none",
        stroke: "currentColor",
        d: "M11.7381 14.6934L10.8106 15.1571C10.7092 15.2078 10.586 15.1642 10.5391 15.061L9.15754 12.0216C9.09703 11.8885 8.91878 11.8632 8.82362 11.9742L7.48486 13.5361C7.36153 13.68 7.12587 13.5876 7.13316 13.3983L7.41419 6.0915C7.42069 5.92237 7.62126 5.83728 7.7474 5.95014L13.1665 10.7988C13.2953 10.9141 13.227 11.1275 13.0552 11.1466L10.8862 11.3876C10.7548 11.4022 10.6735 11.5379 10.7226 11.6607L11.8344 14.4402C11.873 14.5368 11.8312 14.6468 11.7381 14.6934Z"
      }
    ),
    /* @__PURE__ */ jsx33(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4359 6.07847C10.5319 5.74483 10.5833 5.39231 10.5833 5.02778C10.5833 2.9337 8.88574 1.23611 6.79166 1.23611C4.69759 1.23611 3 2.9337 3 5.02778C3 6.7783 4.18626 8.25175 5.79875 8.68811L5.52751 9.65092C3.49452 9.09632 2 7.23658 2 5.02778C2 2.38141 4.1453 0.236115 6.79166 0.236115C9.43803 0.236115 11.5833 2.38141 11.5833 5.02778C11.5833 5.48632 11.5189 5.92981 11.3987 6.34971L10.4359 6.07847Z"
      }
    ),
    /* @__PURE__ */ jsx33(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.59043 5.55861C8.64001 5.39031 8.66662 5.21216 8.66662 5.0278C8.66662 3.99227 7.82716 3.1528 6.79162 3.1528C5.75609 3.1528 4.91663 3.99227 4.91663 5.0278C4.91663 5.89994 5.51208 6.633 6.31861 6.84262L6.04734 7.80552C4.82031 7.47758 3.91663 6.35822 3.91663 5.0278C3.91663 3.43998 5.20381 2.1528 6.79162 2.1528C8.37944 2.1528 9.66662 3.43998 9.66662 5.0278C9.66662 5.30616 9.62706 5.57529 9.55326 5.82985L8.59043 5.55861Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Plus.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var PlusIcon = (props) => {
  return /* @__PURE__ */ jsx34(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Pluss" }, props), { children: /* @__PURE__ */ jsx34(
    "path",
    {
      d: "M14.7499 6.99998H9.00002V1.24995C9.00002 0.697943 8.55202 0.25 7.99993 0.25C7.44795 0.25 6.99998 0.697972 6.99998 1.24995V6.99998H1.24995C0.697972 6.99998 0.25 7.44795 0.25 7.99993C0.25 8.55202 0.697943 9.00002 1.24995 9.00002H6.99998V14.7499C6.99998 15.302 7.44792 15.75 7.99993 15.75C8.55205 15.75 9.00002 15.302 9.00002 14.7499V9.00002H14.7499C15.302 9.00002 15.75 8.55205 15.75 7.99993C15.75 7.44792 15.302 6.99998 14.7499 6.99998Z",
      strokeWidth: "0.5"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Print.tsx
import { jsx as jsx35, jsxs as jsxs23 } from "react/jsx-runtime";
var PrintIcon = (props) => {
  return /* @__PURE__ */ jsxs23(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Print" }, props), { children: [
    /* @__PURE__ */ jsx35(
      "path",
      {
        d: "M11.7917 11.75H13.5417C14.4842 11.75 15.25 10.9835 15.25 10.0417V5.95833C15.25 5.01649 14.4842 4.25 13.5417 4.25H2.45833C1.51578 4.25 0.75 5.01649 0.75 5.95833V10.0417C0.75 10.9835 1.51578 11.75 2.45833 11.75H4.20833C4.5074 11.75 4.75 11.5074 4.75 11.2083C4.75 10.9093 4.5074 10.6667 4.20833 10.6667H2.45833C2.11399 10.6667 1.83333 10.386 1.83333 10.0417V5.95833C1.83333 5.61399 2.11399 5.33333 2.45833 5.33333H13.5417C13.886 5.33333 14.1667 5.61399 14.1667 5.95833V10.0417C14.1667 10.386 13.886 10.6667 13.5417 10.6667H11.7917C11.4926 10.6667 11.25 10.9093 11.25 11.2083C11.25 11.5074 11.4926 11.75 11.7917 11.75Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx35(
      "path",
      {
        d: "M11.25 4.79166C11.25 5.09073 11.4926 5.33333 11.7917 5.33333C12.0908 5.33333 12.3334 5.09073 12.3334 4.79166V2.45833C12.3334 1.51649 11.5676 0.75 10.625 0.75H5.37502C4.43247 0.75 3.66669 1.51649 3.66669 2.45833V4.79166C3.66669 5.09073 3.90928 5.33333 4.20835 5.33333C4.50742 5.33333 4.75002 5.09073 4.75002 4.79166V2.45833C4.75002 2.11399 5.03067 1.83333 5.37502 1.83333H10.625C10.9694 1.83333 11.25 2.11399 11.25 2.45833V4.79166Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx35(
      "path",
      {
        d: "M5.37502 15.25H10.625C11.5676 15.25 12.3334 14.4835 12.3334 13.5416V8.87498C12.3334 8.57591 12.0908 8.33331 11.7917 8.33331H4.20835C3.90928 8.33331 3.66669 8.57591 3.66669 8.87498V13.5416C3.66669 14.4835 4.43247 15.25 5.37502 15.25ZM4.75002 13.5416V9.41665H11.25V13.5416C11.25 13.886 10.9694 14.1667 10.625 14.1667H5.37502C5.03068 14.1667 4.75002 13.886 4.75002 13.5416Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Refresh.tsx
import { jsx as jsx36, jsxs as jsxs24 } from "react/jsx-runtime";
var RefreshIcon = (props) => {
  return /* @__PURE__ */ jsxs24(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 15 16", defaultLabel: "Last inn p\xE5 nytt" }, props), { children: [
    /* @__PURE__ */ jsx36(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.63524 10.1832C6.46082 9.6589 5.8944 9.37512 5.36998 9.54959C5.36998 9.54959 2.46158 10.5117 2.36981 10.5496C1.68579 10.8321 1.68579 10.8206 1.68579 11.5006V14.5C1.68579 15.0523 2.13351 15.5 2.6858 15.5C3.2381 15.5 3.68582 15.0523 3.68582 14.5V13.7343C6.4501 15.6779 10.294 15.3772 12.7186 12.8728C13.9835 11.5663 14.6892 9.81803 14.6859 7.99951C14.6857 7.44738 14.238 6.99998 13.6859 6.99998C13.1808 6.99998 12.6859 7.46484 12.6954 7.97948C12.6956 7.98831 12.6859 7.99999 12.6859 7.99999C12.6853 10.7614 10.4463 12.9994 7.68486 12.9989C6.55191 12.9987 5.46113 12.6141 4.58452 11.9209L6.00196 11.4483C6.52604 11.2738 6.80969 10.7075 6.63524 10.1832Z"
      }
    ),
    /* @__PURE__ */ jsx36(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.73646 5.31683C8.91089 5.8411 9.47731 6.12488 10.0017 5.95041C10.0017 5.95041 12.9101 4.98827 13.0019 4.95037C13.6859 4.66789 13.6859 4.67943 13.6859 3.99936V1.00001C13.6859 0.447716 13.2382 3.8147e-06 12.6859 3.8147e-06C12.1336 3.8147e-06 11.6859 0.447716 11.6859 1.00001V1.76571C8.9216 -0.177855 5.07774 0.122791 2.65311 2.62721C1.38818 3.93375 0.682467 5.68197 0.685844 7.50049C0.686045 8.05262 1.13372 8.50002 1.6858 8.50002C2.19087 8.50002 2.68581 8.03516 2.67628 7.52052C2.67612 7.51169 2.68581 7.50001 2.68581 7.50001C2.68642 4.73864 4.92542 2.50055 7.68685 2.50111C8.81979 2.50133 9.91058 2.88592 10.7872 3.57909L9.36974 4.05167C8.84566 4.22621 8.56202 4.79251 8.73646 5.31683Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Search.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var SearchIcon = (props) => {
  return /* @__PURE__ */ jsx37(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "S\xF8k" }, props), { children: /* @__PURE__ */ jsx37(
    "path",
    {
      d: "M15.9905 14.506L15.9906 14.5061C16.2794 14.7906 16.2795 15.2539 15.9901 15.5384C15.9901 15.5385 15.99 15.5386 15.9899 15.5387L15.8147 15.3603C15.6253 15.547 15.3177 15.547 15.1283 15.3603L15.9905 14.506ZM15.9905 14.506L12.2868 10.8616C13.2459 9.73973 13.8296 8.29404 13.8296 6.71064V6.71061C13.8291 3.13855 10.888 0.25 7.26814 0.25C3.64828 0.25 0.707153 3.13855 0.707153 6.71064C0.707153 10.2827 3.64828 13.1713 7.26814 13.1713C8.75249 13.1713 10.121 12.684 11.2204 11.8654L14.9528 15.5384L15.9905 14.506ZM7.26814 11.7157C4.45324 11.7157 2.17819 9.47113 2.17819 6.71064C2.17819 3.95016 4.45324 1.70554 7.26814 1.70554C10.0831 1.70554 12.3581 3.95016 12.3581 6.71064C12.3581 9.47113 10.0831 11.7157 7.26814 11.7157Z",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/User.tsx
import { jsx as jsx38, jsxs as jsxs25 } from "react/jsx-runtime";
var UserIcon = (props) => {
  return /* @__PURE__ */ jsxs25(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Bruker" }, props), { children: [
    /* @__PURE__ */ jsx38("path", { d: "M12.5948 8.05036C12.3395 8.06942 12.0906 8.13986 11.8629 8.2575C11.6353 8.37514 11.4336 8.53755 11.2699 8.73507C10.945 9.09 10.549 9.37212 10.1079 9.56299C9.66687 9.75385 9.1906 9.84916 8.71027 9.84268C8.22098 9.85377 7.73498 9.75978 7.28487 9.56701C6.83476 9.37424 6.43093 9.08715 6.10049 8.725C5.76749 8.33563 5.29517 8.09331 4.78556 8.05036C3.69145 8.05036 0.86084 9.10763 0.86084 10.7892C0.86084 12.2694 3.10927 15.8238 8.70024 15.8238C14.2912 15.8238 16.5095 12.2895 16.5095 10.7892C16.5095 9.10763 13.7291 8.05036 12.5948 8.05036ZM15.1846 11.0711C14.9738 12.078 12.8458 14.5551 8.83073 14.5551H8.53963C4.52458 14.5551 2.3966 12.1083 2.18581 11.0711C2.17611 10.979 2.18733 10.8858 2.21862 10.7986C2.24991 10.7114 2.30046 10.6325 2.36649 10.5677C2.99898 9.91617 3.84262 9.51266 4.74541 9.42984C4.92751 9.53259 5.09611 9.65774 5.24729 9.8024C6.16219 10.6992 7.37249 11.2292 8.65005 11.2926H8.71027C9.99135 11.2316 11.2056 10.7014 12.1231 9.8024C12.2743 9.65774 12.4429 9.53259 12.625 9.42984C13.5211 9.49905 14.3639 9.88431 15.0039 10.5173C15.0773 10.5874 15.1323 10.6747 15.1638 10.7714C15.1954 10.868 15.2025 10.971 15.1846 11.0711Z" }),
    /* @__PURE__ */ jsx38(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5955 7.87415C13.2001 7.87415 14.2085 8.15037 15.0646 8.63578C15.9121 9.11631 16.6858 9.84636 16.6858 10.7892C16.6858 11.6071 16.0945 12.9108 14.816 14.0032C13.5287 15.1033 11.5353 16 8.70085 16C5.86615 16 3.8654 15.0981 2.57087 13.9959C1.28564 12.9016 0.685791 11.598 0.685791 10.7892C0.685791 9.84505 1.47403 9.11515 2.32767 8.63545C3.19056 8.15056 4.20126 7.87415 4.78617 7.87415H4.79353L4.80087 7.87476C5.35549 7.9215 5.86958 8.18485 6.23251 8.60803C6.54571 8.95071 6.9282 9.2224 7.35445 9.40494C7.78153 9.58785 8.24266 9.67703 8.70692 9.66651L8.71325 9.66637C9.16885 9.67251 9.6206 9.58222 10.039 9.40118C10.4561 9.22069 10.8306 8.95417 11.1383 8.61896C11.3166 8.40481 11.5358 8.22864 11.7831 8.10085C12.0317 7.97238 12.3035 7.89544 12.5824 7.87463L12.5955 7.87415ZM2.49937 8.94292C1.66418 9.41224 1.03711 10.0518 1.03711 10.7892C1.03711 11.4605 1.56147 12.6742 2.7982 13.7272C4.02563 14.7723 5.94457 15.6476 8.70085 15.6476C11.4574 15.6476 13.3686 14.7772 14.5882 13.735C15.8166 12.6852 16.3345 11.4716 16.3345 10.7892C16.3345 10.0504 15.718 9.41109 14.8917 8.94259C14.0774 8.48088 13.1328 8.22864 12.602 8.22658C12.3724 8.24458 12.1487 8.30834 11.944 8.41414C11.7373 8.52094 11.5542 8.6684 11.4056 8.84772L11.4 8.85439C11.0584 9.22759 10.6419 9.52409 10.1781 9.72478C9.71532 9.92505 9.21566 10.0253 8.71169 10.0189C8.19843 10.0301 7.68868 9.93128 7.21651 9.72907C6.74336 9.52643 6.31888 9.22465 5.97152 8.84397L5.96771 8.83979C5.66636 8.48742 5.23966 8.26736 4.77882 8.22659C4.26786 8.22899 3.32136 8.48101 2.49937 8.94292ZM4.78447 9.24936L4.83213 9.27625C5.02698 9.38619 5.20738 9.52011 5.36914 9.67489L5.37067 9.67636C6.25387 10.542 7.4219 11.0541 8.65504 11.1164H8.70668C9.94329 11.0565 11.1152 10.5442 12.0009 9.67635L12.0024 9.67488C12.1642 9.5201 12.3446 9.38619 12.5395 9.27625L12.5859 9.25004L12.639 9.25415C13.5761 9.32651 14.4573 9.72916 15.1267 10.3908C15.2207 10.4808 15.291 10.5927 15.3314 10.7165C15.372 10.8409 15.3811 10.9735 15.358 11.1023L15.1852 11.0711L15.3571 11.1073C15.2967 11.3959 15.1067 11.7642 14.8064 12.1489C14.5034 12.537 14.0793 12.9529 13.5356 13.335C12.4471 14.1 10.8764 14.7313 8.83134 14.7313H8.54025C6.49571 14.7313 4.92508 14.1079 3.83628 13.3466C3.29245 12.9663 2.86822 12.5512 2.56503 12.1614C2.26428 11.7748 2.07449 11.4025 2.0143 11.1063L2.01261 11.098L2.01173 11.0896C1.99925 10.971 2.01369 10.8511 2.05396 10.7389C2.09397 10.6274 2.15847 10.5264 2.24265 10.4433C2.9042 9.76254 3.78621 9.34094 4.73002 9.25436L4.78447 9.24936ZM15.0127 11.0375C15.025 10.9669 15.0197 10.8943 14.9975 10.8262C14.975 10.7572 14.9358 10.695 14.8834 10.645L14.8811 10.6428C14.2834 10.0517 13.5004 9.68703 12.6657 9.61007C12.5141 9.70019 12.3732 9.80727 12.2456 9.92929C11.2975 10.8579 10.0428 11.4056 8.71922 11.4687L8.71089 11.4691L8.64196 11.4689C7.32194 11.4033 6.0714 10.8556 5.12592 9.9292C4.99867 9.80754 4.85816 9.70073 4.70709 9.61078C3.86673 9.70081 3.08338 10.0824 2.49294 10.6906L2.48999 10.6936C2.4429 10.7399 2.40682 10.7961 2.38451 10.8583C2.36311 10.9179 2.35488 10.9815 2.36033 11.0445C2.40775 11.2666 2.56263 11.5855 2.842 11.9446C3.12256 12.3053 3.52078 12.6964 4.03718 13.0575C5.06884 13.7788 6.56972 14.3789 8.54025 14.3789H8.83134C10.8013 14.3789 12.3021 13.7716 13.3341 13.0464C13.8506 12.6834 14.249 12.2912 14.5298 11.9316C14.812 11.5702 14.967 11.2524 15.0127 11.0375Z"
      }
    ),
    /* @__PURE__ */ jsx38("path", { d: "M8.71092 0.176231C8.21754 0.184017 7.73063 0.290087 7.27846 0.488276C6.8263 0.686465 6.41791 0.972822 6.07703 1.33071C5.73614 1.68859 5.46956 2.11087 5.29276 2.573C5.11597 3.03513 5.03249 3.5279 5.04718 4.02267C5.03377 5.01174 5.41194 5.96578 6.09877 6.67552C6.78559 7.38527 7.72499 7.79279 8.71092 7.8087C9.68806 7.77972 10.6147 7.36646 11.2907 6.65814C11.9668 5.94981 12.3381 5.00322 12.3245 4.02267C12.3392 3.53204 12.2574 3.04331 12.0837 2.58442C11.91 2.12552 11.6479 1.70546 11.3123 1.34824C10.9767 0.991021 10.5742 0.703648 10.1279 0.502548C9.68152 0.301448 9.20003 0.190563 8.71092 0.176231ZM8.71092 6.53997C8.05596 6.52675 7.43259 6.25506 6.97599 5.78383C6.51939 5.3126 6.26636 4.67981 6.27178 4.02267C6.25971 3.69188 6.3136 3.362 6.43027 3.05237C6.54694 2.74274 6.72405 2.45958 6.95122 2.2195C7.1784 1.97943 7.45106 1.78725 7.75322 1.65425C8.05539 1.52125 8.38099 1.45009 8.71092 1.44495C9.03658 1.45664 9.35674 1.53261 9.6531 1.66852C9.94947 1.80443 10.2162 1.99761 10.4381 2.23702C10.66 2.47643 10.8326 2.75736 10.9462 3.06376C11.0597 3.37016 11.112 3.69601 11.0999 4.02267C11.1056 4.67135 10.8595 5.29682 10.4136 5.76666C9.96772 6.2365 9.35707 6.51384 8.71092 6.53997Z" }),
    /* @__PURE__ */ jsx38(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.20813 0.326763C7.68162 0.119226 8.19151 0.00815308 8.70816 0L8.71092 0.176189L8.71605 5.33253e-05C9.22823 0.0150609 9.73243 0.131176 10.1999 0.341762C10.6673 0.552348 11.0887 0.853276 11.4402 1.22735C11.7916 1.60141 12.0661 2.04129 12.2479 2.52183C12.4293 3.00117 12.515 3.51159 12.5002 4.02406C12.5134 5.04948 12.1247 6.03916 11.4176 6.77996C10.7097 7.5217 9.73935 7.95444 8.71611 7.98479L8.70809 7.98503L8.7081 7.98484C7.67566 7.96819 6.69195 7.54145 5.97273 6.79822C5.25439 6.05591 4.85847 5.05841 4.87149 4.02405C4.85665 3.50723 4.94409 2.99256 5.12876 2.50982C5.3139 2.02589 5.59306 1.5837 5.95002 1.20893C6.30699 0.834166 6.73464 0.534301 7.20813 0.326763ZM8.70974 0.352443C8.24098 0.360364 7.77842 0.461392 7.3488 0.649704C6.91796 0.838545 6.52884 1.11139 6.20403 1.4524C5.87922 1.7934 5.62521 2.19576 5.45676 2.63609C5.2883 3.07642 5.20877 3.54595 5.22276 4.01738L5.22299 4.02503L5.22283 4.02503C5.21004 4.96744 5.57038 5.87648 6.22481 6.55275C6.8783 7.22805 7.77177 7.61621 8.70974 7.6324C9.63931 7.60378 10.5206 7.21018 11.1638 6.53623C11.808 5.86132 12.1618 4.95938 12.1488 4.02508L12.1487 4.01732L12.1489 4.01733C12.1629 3.54984 12.085 3.08416 11.9195 2.64692C11.754 2.20967 11.5042 1.80942 11.1845 1.46905C10.8647 1.12868 10.4812 0.854864 10.0559 0.66325C9.63181 0.472176 9.17442 0.366578 8.70974 0.352443ZM8.71721 1.26858L8.7172 1.26881C9.06593 1.28133 9.40878 1.36268 9.72614 1.50822C10.0435 1.65376 10.3291 1.86063 10.5667 2.117C10.8043 2.37337 10.9892 2.67421 11.1108 3.00231C11.232 3.32915 11.2879 3.67666 11.2756 4.02511C11.2807 4.71812 11.0173 5.3861 10.5408 5.88812C10.0635 6.39111 9.40974 6.68802 8.718 6.716L8.71092 6.53993L8.70739 6.71611C8.0062 6.70195 7.33885 6.41109 6.85003 5.90661C6.36212 5.40307 6.09134 4.72721 6.09609 4.02512C6.08375 3.67222 6.14148 3.32036 6.26596 2.99002C6.39089 2.65845 6.58055 2.35524 6.82382 2.09815C7.06709 1.84106 7.35907 1.63527 7.68264 1.49285C8.00622 1.35042 8.35488 1.27422 8.70819 1.26872L8.71721 1.26858ZM8.70915 6.36364C9.30774 6.33806 9.87318 6.08052 10.2864 5.64512C10.7008 5.20843 10.9296 4.6271 10.9242 4.02419L10.9242 4.01609L10.9243 4.0161C10.9356 3.71258 10.887 3.40982 10.7815 3.12513C10.676 2.84044 10.5156 2.5794 10.3094 2.35696C10.1033 2.13451 9.85543 1.95502 9.58007 1.82874C9.30607 1.70308 9.01017 1.63257 8.70914 1.62118C8.40413 1.62652 8.10319 1.6926 7.82381 1.81557C7.54305 1.93915 7.2897 2.11771 7.07863 2.34077C6.86755 2.56384 6.70299 2.82693 6.59458 3.11463C6.48617 3.40232 6.43611 3.70883 6.44732 4.01619L6.4476 4.02409L6.44743 4.02409C6.44239 4.63485 6.67757 5.22299 7.10195 5.66097C7.52509 6.09768 8.10234 6.34999 8.70915 6.36364Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/UserFilled.tsx
import { jsx as jsx39, jsxs as jsxs26 } from "react/jsx-runtime";
var UserFilledIcon = (props) => {
  return /* @__PURE__ */ jsxs26(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Bruker" }, props), { children: [
    /* @__PURE__ */ jsx39("path", { d: "M12.8805 8.05034C12.6251 8.06939 12.3762 8.13984 12.1486 8.25748C11.9209 8.37511 11.7192 8.53753 11.5555 8.73505C11.2306 9.08997 10.8347 9.3721 10.3936 9.56297C9.95251 9.75383 9.47624 9.84914 8.99592 9.84266C8.50663 9.85375 8.02063 9.75976 7.57051 9.56699C7.1204 9.37422 6.71658 9.08713 6.38613 8.72498C6.05314 8.33561 5.58082 8.09328 5.0712 8.05034C3.9771 8.05034 1.14648 9.10761 1.14648 10.7892C1.14648 12.2694 3.39492 15.8238 8.98588 15.8238C14.5768 15.8238 16.7952 12.2895 16.7952 10.7892C16.7952 9.10761 14.0147 8.05034 12.8805 8.05034Z" }),
    /* @__PURE__ */ jsx39(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8811 7.87364V7.87413C13.4858 7.87413 14.4941 8.15035 15.3502 8.63577C16.1977 9.11629 16.9714 9.84635 16.9714 10.7892C16.9714 11.6071 16.3801 12.9108 15.1017 14.0032C13.8144 15.1033 11.8209 16 8.98649 16C6.1518 16 4.15104 15.0981 2.85651 13.9959C1.57129 12.9016 0.971436 11.598 0.971436 10.7892C0.971436 9.84503 1.75967 9.11514 2.61332 8.63544C3.4762 8.15054 4.48691 7.87413 5.07181 7.87413H5.07918L5.08652 7.87475C5.64113 7.92148 6.15523 8.18483 6.51816 8.60802C6.83135 8.95069 7.21385 9.22238 7.64009 9.40493C8.06718 9.58784 8.52831 9.67702 8.99256 9.6665L8.99889 9.66635L8.99889 9.66647C9.45449 9.67262 9.90625 9.58221 10.3246 9.40117C10.7417 9.22068 11.1163 8.95416 11.4239 8.61894C11.6022 8.40479 11.8214 8.22862 12.0687 8.10083C12.3173 7.97236 12.5892 7.89542 12.8681 7.87461L12.8811 7.87364ZM2.78501 8.94291C1.94983 9.41223 1.32275 10.0517 1.32275 10.7892C1.32275 11.4605 1.84711 12.6742 3.08385 13.7272C4.31128 14.7723 6.23022 15.6476 8.98649 15.6476C11.743 15.6476 13.6542 14.7772 14.8738 13.735C16.1023 12.6852 16.6201 11.4716 16.6201 10.7892C16.6201 10.0504 16.0036 9.41108 15.1773 8.94257C14.363 8.48086 13.4184 8.22862 12.8876 8.22656C12.6581 8.24457 12.4344 8.30832 12.2296 8.41413C12.0229 8.52093 11.8398 8.66839 11.6912 8.84771L11.6857 8.85438L11.6855 8.85424C11.3439 9.22743 10.9276 9.52408 10.4638 9.72477C10.001 9.92504 9.5013 10.0253 8.99733 10.0189C8.48407 10.0301 7.97433 9.93127 7.50215 9.72905C7.02901 9.52642 6.60452 9.22464 6.25717 8.84395L6.25335 8.83978L6.25342 8.83972C5.95207 8.48735 5.5253 8.26734 5.06447 8.22657C4.5535 8.22897 3.607 8.48099 2.78501 8.94291Z"
      }
    ),
    /* @__PURE__ */ jsx39("path", { d: "M8.99657 0.176193C8.50319 0.183979 8.01627 0.290049 7.56411 0.488238C7.11195 0.686428 6.70356 0.972786 6.36267 1.33067C6.02179 1.68856 5.7552 2.11084 5.57841 2.57297C5.40161 3.0351 5.31814 3.52787 5.33283 4.02264C5.31941 5.01172 5.69759 5.96575 6.38441 6.6755C7.07124 7.38525 8.01063 7.79277 8.99657 7.80868C9.97371 7.7797 10.9003 7.36644 11.5764 6.65812C12.2524 5.94979 12.6237 5.00319 12.6101 4.02264C12.6248 3.53201 12.543 3.04328 12.3693 2.58438C12.1957 2.12549 11.9336 1.70542 11.598 1.3482C11.2624 0.990984 10.8599 0.703611 10.4135 0.50251C9.96717 0.30141 9.48567 0.190525 8.99657 0.176193Z" }),
    /* @__PURE__ */ jsx39(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.49378 0.326764C7.96727 0.119226 8.47715 0.0081531 8.9938 0L8.99657 0.17619L9.0017 5.33254e-05C9.51387 0.0150609 10.0181 0.131176 10.4855 0.341763C10.9529 0.552349 11.3744 0.853278 11.7258 1.22735C12.0772 1.60142 12.3517 2.0413 12.5336 2.52184C12.715 3.00117 12.8007 3.51159 12.7858 4.02407C12.799 5.04949 12.4103 6.03917 11.7032 6.77998C10.9953 7.52171 10.025 7.95446 9.00176 7.98481L8.99374 7.98505L8.99374 7.98486C7.9613 7.96821 6.97759 7.54147 6.25837 6.79824C5.54004 6.05592 5.14411 5.05843 5.15713 4.02406C5.14229 3.50724 5.22973 2.99257 5.41441 2.50983C5.59954 2.0259 5.8787 1.5837 6.23567 1.20894C6.59263 0.834168 7.02029 0.534303 7.49378 0.326764ZM8.99538 0.352444C8.52663 0.360365 8.06407 0.461393 7.63444 0.649706C7.20361 0.838547 6.81448 1.1114 6.48967 1.4524C6.16487 1.79341 5.91086 2.19577 5.7424 2.6361C5.57395 3.07643 5.49441 3.54596 5.50841 4.01739L5.50864 4.02504L5.50847 4.02504C5.49569 4.96746 5.85602 5.87649 6.51045 6.55276C7.16395 7.22807 8.05742 7.61622 8.99538 7.63242C9.92496 7.60379 10.8062 7.2102 11.4495 6.53625C12.0937 5.86133 12.4474 4.95939 12.4345 4.02509L12.4344 4.01733L12.4345 4.01734C12.4486 3.54985 12.3706 3.08417 12.2051 2.64692C12.0396 2.20967 11.7899 1.80942 11.4701 1.46905C11.1504 1.12868 10.7669 0.854866 10.3416 0.663251C9.91746 0.472177 9.46006 0.366579 8.99538 0.352444Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Warning.tsx
import { jsx as jsx40, jsxs as jsxs27 } from "react/jsx-runtime";
var WarningIcon = (props) => {
  return /* @__PURE__ */ jsxs27(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Feilikon" }, props), { children: [
    /* @__PURE__ */ jsx40(
      "path",
      {
        d: "M8.94762 2.67007L15.1112 13.1701C15.1346 13.2099 15.1393 13.2775 15.1069 13.3376C15.0807 13.3861 15.0252 13.4375 14.9064 13.4375H2.57924C2.46036 13.4375 2.40494 13.3861 2.37873 13.3376C2.34625 13.2775 2.35102 13.2099 2.37441 13.1701L8.53797 2.67007C8.62216 2.52664 8.86343 2.52664 8.94762 2.67007ZM10.1141 1.96719C9.50382 0.927602 7.98177 0.927603 7.37153 1.96719L1.20797 12.4672C0.592849 13.5151 1.36601 14.8125 2.57924 14.8125H14.9064C16.1196 14.8125 16.8927 13.5151 16.2776 12.4672L10.1141 1.96719Z",
        strokeWidth: "0.5"
      }
    ),
    /* @__PURE__ */ jsx40("rect", { x: "7.7428", y: "10.8117", width: "2", height: "2", rx: "1" }),
    /* @__PURE__ */ jsx40("rect", { x: "7.7428", y: "4.97722", width: "2", height: "4.91358", rx: "1" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/SmallCheckmark.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var SmallCheckmarkIcon = (props) => {
  return /* @__PURE__ */ jsx41(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 8 8", defaultLabel: "liten hake", $size: 8 }, props), { children: /* @__PURE__ */ jsx41("path", { d: "M7.47407 1.16497C7.25999 0.943823 6.91053 0.945192 6.69811 1.16801L3.08235 5.01417L1.31877 3.08088C1.10486 2.85648 0.754265 2.85082 0.533549 3.0682L0.176571 3.37685C-0.0466247 3.59667 -0.0599443 3.95798 0.146432 4.19441L2.29648 6.55137L2.50579 6.76442C2.82167 7.06858 3.31075 7.07949 3.63927 6.78971L7.85006 2.35742C8.0578 2.11942 8.04867 1.7569 7.82921 1.53019L7.47407 1.16497Z" }) }));
};

// ../udir-lisa/src/components/Icon/icons/SmallCircle.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var SmallCircleIcon = (props) => {
  return /* @__PURE__ */ jsx42(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 8 8", defaultLabel: "Liten sirkel", $size: 8 }, props), { children: /* @__PURE__ */ jsx42("circle", { cx: "4", cy: "4", r: "3" }) }));
};

// ../udir-lisa/src/components/Icon/icons/SmallLine.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var SmallLineIcon = (props) => {
  return /* @__PURE__ */ jsx43(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 7 7", defaultLabel: "liten strek", $size: 7 }, props), { children: /* @__PURE__ */ jsx43("rect", { y: "3", width: "8", height: "2" }) }));
};

// ../udir-lisa/src/components/Icon/icons/CircledChevron.tsx
import { jsx as jsx44, jsxs as jsxs28 } from "react/jsx-runtime";
var CircledChevronIcon = (props) => /* @__PURE__ */ jsxs28(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Sirkel ikon" }, props), { children: [
  /* @__PURE__ */ jsx44("circle", { cx: "8", cy: "8", r: "7.25", fill: "transparent", stroke: "currentColor", strokeWidth: "1.5" }),
  /* @__PURE__ */ jsx44("g", { transform: "translate(4 3.4)", children: /* @__PURE__ */ jsx44(
    "path",
    {
      d: "M6.83662 5.55081C6.98306 5.40436 6.98306 5.16693 6.83661 5.02048L4.26517 2.44911C4.11872 2.30267 3.88129 2.30267 3.73484 2.44911L1.16342 5.02054C1.01698 5.16699 1.01698 5.40442 1.16342 5.55087C1.30987 5.69732 1.54731 5.69732 1.69375 5.55087L4.00001 3.2446L6.30628 5.55082C6.45273 5.69726 6.69017 5.69726 6.83662 5.55081ZM6.83662 5.55081L6.72297 5.43717L6.83662 5.55081ZM1.39071 5.32359C1.36979 5.30267 1.36979 5.26875 1.39071 5.24782L3.96213 2.6764C3.98305 2.65548 4.01697 2.65548 4.03789 2.6764L6.60933 5.24777C6.63025 5.26869 6.63025 5.30261 6.60933 5.32353L6.72245 5.43665L6.60933 5.32353C6.58841 5.34445 6.55449 5.34445 6.53357 5.32353L4.11365 2.90368C4.05089 2.84092 3.94913 2.84092 3.88637 2.90368L1.46647 5.32359C1.44555 5.34451 1.41163 5.34451 1.39071 5.32359Z",
      stroke: "currentColor",
      strokeWidth: "0.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) })
] }));

// ../udir-lisa/src/components/Icon/icons/Copy.tsx
import { jsx as jsx45, jsxs as jsxs29 } from "react/jsx-runtime";
var Copy = (props) => {
  return /* @__PURE__ */ jsxs29(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Kopier" }, props), { children: [
    /* @__PURE__ */ jsx45("path", { d: "M14.9243 1.5V10.5H13.7875V12H15.4243C15.9766 12 16.4243 11.5523 16.4243 11V1C16.4243 0.447715 15.9766 0 15.4243 0H5.42432C4.87203 0 4.42432 0.447715 4.42432 1V2.45095H5.92432V1.5H14.9243Z" }),
    /* @__PURE__ */ jsx45(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.92859 5.50449V14.5045H10.9286V5.50449H1.92859ZM1.42859 4.00449C0.876304 4.00449 0.428589 4.4522 0.428589 5.00449V15.0045C0.428589 15.5568 0.876304 16.0045 1.42859 16.0045H11.4286C11.9809 16.0045 12.4286 15.5568 12.4286 15.0045V5.00449C12.4286 4.4522 11.9809 4.00449 11.4286 4.00449H1.42859Z"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Shield.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var ShieldIcon = (props) => {
  return /* @__PURE__ */ jsx46(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Skjold ikon" }, props), { children: /* @__PURE__ */ jsx46(
    "path",
    {
      d: "M15.7813 2.84781C15.7848 2.49951 15.5491 2.19372 15.2135 2.10422L15.2133 2.10416L8.19452 0.24479L8.19449 0.244784C8.06698 0.211031 7.93274 0.211262 7.80325 0.244557L7.80236 0.244794L0.786733 2.10417L0.786548 2.10422C0.450918 2.19372 0.215198 2.49951 0.21876 2.84781C0.256597 7.86435 2.87716 12.6274 7.5761 15.652L7.57632 15.6521C7.95906 15.8974 8.29771 15.7349 8.42491 15.6513L8.42603 15.6506C13.0587 12.5338 15.7465 7.8694 15.7813 2.84781ZM15.7813 2.84781C15.7813 2.84795 15.7812 2.84808 15.7812 2.84822L15.6563 2.84687L15.7813 2.84774C15.7813 2.84776 15.7813 2.84779 15.7813 2.84781ZM14.2419 3.42611C14.014 7.54953 11.7764 11.3872 8.00001 14.0903C4.22355 11.3871 1.98608 7.54949 1.76426 3.42615L8.00313 1.77306L14.2419 3.42611Z",
      fill: "currentColor",
      strokeWidth: "0.25"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Dots.tsx
import { jsx as jsx47, jsxs as jsxs30 } from "react/jsx-runtime";
var DotsIcon = (props) => {
  return /* @__PURE__ */ jsxs30(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Prikker" }, props), { children: [
    /* @__PURE__ */ jsx47(
      "path",
      {
        d: "M11 2C11 3.10457 10.1046 4 9 4C7.89543 4 7 3.10457 7 2C7 0.89543 7.89543 0 9 0C10.1046 0 11 0.89543 11 2Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx47(
      "path",
      {
        d: "M11 8C11 9.10457 10.1046 10 9 10C7.89543 10 7 9.10457 7 8C7 6.89543 7.89543 6 9 6C10.1046 6 11 6.89543 11 8Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx47(
      "path",
      {
        d: "M11 14C11 15.1046 10.1046 16 9 16C7.89543 16 7 15.1046 7 14C7 12.8954 7.89543 12 9 12C10.1046 12 11 12.8954 11 14Z",
        fill: "currentColor"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Sort.tsx
import { jsx as jsx48, jsxs as jsxs31 } from "react/jsx-runtime";
var SortIcon = (props) => {
  return /* @__PURE__ */ jsxs31(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 16 16", defaultLabel: "Sortering" }, props), { children: [
    /* @__PURE__ */ jsx48(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.09572 9.64181C8.29355 9.44914 8.6101 9.45332 8.80277 9.65114L12.0001 12.934L15.1975 9.65114C15.3902 9.45332 15.7067 9.44914 15.9045 9.64181C16.1024 9.83448 16.1065 10.151 15.9139 10.3489L12.3583 13.9995C12.2642 14.0962 12.135 14.1507 12.0001 14.1507C11.8652 14.1507 11.7361 14.0962 11.6419 13.9995L8.08639 10.3489C7.89372 10.151 7.8979 9.83448 8.09572 9.64181Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.53563 2.53523C4.73091 2.34009 5.04739 2.34015 5.2426 2.53536L8.79816 6.09092C8.99342 6.28618 8.99342 6.60276 8.79816 6.79803C8.6029 6.99329 8.28632 6.99329 8.09105 6.79803L4.88892 3.59589L1.68692 6.79549C1.49158 6.99068 1.175 6.99056 0.97981 6.79523C0.784621 6.59989 0.78474 6.28331 0.980075 6.08812L4.53563 2.53523Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.88904 2.38892C5.16518 2.38892 5.38904 2.61277 5.38904 2.88892V13.5556C5.38904 13.8317 5.16518 14.0556 4.88904 14.0556C4.6129 14.0556 4.38904 13.8317 4.38904 13.5556V2.88892C4.38904 2.61277 4.6129 2.38892 4.88904 2.38892Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 2.38892C12.2763 2.38892 12.5001 2.61277 12.5001 2.88892V13.5556C12.5001 13.8317 12.2763 14.0556 12.0001 14.0556C11.724 14.0556 11.5001 13.8317 11.5001 13.5556V2.88892C11.5001 2.61277 11.724 2.38892 12.0001 2.38892Z",
        fill: "currentColor"
      }
    )
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/SmallQuestionmark.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var SmallQuestionmarkIcon = (props) => {
  return /* @__PURE__ */ jsx49(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 8 8", defaultLabel: "lite sp\xF8rsm\xE5lstegn", $size: 8 }, props), { children: /* @__PURE__ */ jsx49("path", { d: "M4.68134 5.45699H3.1596C3.1596 5.14158 3.18081 4.8638 3.22322 4.62366C3.26918 4.37993 3.34694 4.16129 3.45652 3.96774C3.5661 3.77419 3.71456 3.59498 3.90191 3.43011C4.06805 3.29032 4.21121 3.15591 4.33139 3.02688C4.45157 2.89785 4.54348 2.76703 4.60711 2.63441C4.67073 2.50179 4.70255 2.36022 4.70255 2.20968C4.70255 2.0233 4.67603 1.87097 4.62301 1.75269C4.57352 1.63441 4.49753 1.5466 4.39502 1.48925C4.29604 1.42832 4.17056 1.39785 4.01856 1.39785C3.89484 1.39785 3.77819 1.42832 3.66861 1.48925C3.56257 1.55018 3.47596 1.64516 3.4088 1.77419C3.34164 1.89964 3.30452 2.06631 3.29746 2.27419H1.5C1.5106 1.74014 1.62725 1.30645 1.84995 0.973118C2.07618 0.636201 2.37663 0.390681 2.75133 0.236559C3.12955 0.078853 3.55196 0 4.01856 0C4.53464 0 4.97826 0.0806452 5.34942 0.241935C5.72057 0.403226 6.00513 0.643369 6.20308 0.962366C6.40103 1.27778 6.5 1.66667 6.5 2.12903C6.5 2.43728 6.44168 2.70609 6.32503 2.93548C6.21191 3.16129 6.05815 3.37276 5.86373 3.56989C5.67285 3.76344 5.459 3.97133 5.22216 4.19355C5.01714 4.37634 4.87752 4.56272 4.80329 4.75269C4.72906 4.93907 4.68841 5.17384 4.68134 5.45699ZM2.94221 7.0914C2.94221 6.83333 3.03411 6.61828 3.21792 6.44624C3.40173 6.27061 3.64033 6.1828 3.93372 6.1828C4.22711 6.1828 4.46571 6.27061 4.64952 6.44624C4.83333 6.61828 4.92524 6.83333 4.92524 7.0914C4.92524 7.34946 4.83333 7.56631 4.64952 7.74194C4.46571 7.91398 4.22711 8 3.93372 8C3.64033 8 3.40173 7.91398 3.21792 7.74194C3.03411 7.56631 2.94221 7.34946 2.94221 7.0914Z" }) }));
};

// ../udir-lisa/src/components/Icon/icons/SmallExit.tsx
import { jsx as jsx50, jsxs as jsxs32 } from "react/jsx-runtime";
var SmallExitIcon = (props) => {
  return /* @__PURE__ */ jsxs32(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 8 8", defaultLabel: "lite kryss", $size: 8 }, props), { children: [
    /* @__PURE__ */ jsx50("path", { d: "M6.19747 1.25306L3.99993 3.4506L1.80234 1.25301C1.65074 1.10142 1.40458 1.10141 1.25293 1.25306C1.10133 1.40466 1.10133 1.65083 1.25293 1.80243L3.45052 4.00002L1.25293 6.19761C1.10133 6.34921 1.10133 6.59537 1.25293 6.74697C1.40458 6.89862 1.65074 6.89862 1.80234 6.74702L3.99993 4.54943L6.19747 6.74697C6.34912 6.89862 6.59528 6.89862 6.74688 6.74702C6.89853 6.59537 6.89853 6.34921 6.74688 6.19756L4.54934 4.00002L6.74688 1.80247C6.89853 1.65082 6.89853 1.40466 6.74688 1.25301C6.59528 1.10141 6.34912 1.10141 6.19747 1.25306Z" }),
    /* @__PURE__ */ jsx50("path", { d: "M3.99998 3.08434L6.01439 1.06993C6.26716 0.817164 6.6773 0.81712 6.93007 1.06988C7.18286 1.32267 7.18286 1.73282 6.93007 1.98561L4.91566 4.00002L6.93007 6.01442C7.18286 6.26721 7.18286 6.67736 6.93007 6.93015C6.6773 7.18291 6.26716 7.18287 6.01439 6.9301L3.99998 4.91569L1.98553 6.93015C1.73276 7.18291 1.32262 7.18287 1.06985 6.9301C0.817112 6.67736 0.817112 6.26721 1.06985 6.01447L3.08431 4.00002L1.06985 1.98556C0.817112 1.73282 0.817112 1.32267 1.06985 1.06993C1.32262 0.817164 1.73276 0.81712 1.98553 1.06988L3.99998 3.08434ZM6.19753 1.25306C6.34918 1.10141 6.59534 1.10141 6.74694 1.25301C6.89859 1.40466 6.89859 1.65082 6.74694 1.80247L4.54939 4.00002L6.74694 6.19756C6.89859 6.34921 6.89859 6.59537 6.74694 6.74702C6.59534 6.89862 6.34918 6.89862 6.19753 6.74697L3.99998 4.54943L1.80239 6.74702C1.65079 6.89862 1.40463 6.89862 1.25298 6.74697C1.10138 6.59537 1.10138 6.34921 1.25298 6.19761L3.45057 4.00002L1.25298 1.80242C1.10138 1.65083 1.10138 1.40466 1.25298 1.25306C1.40463 1.10141 1.65079 1.10142 1.80239 1.25301L3.99998 3.45061L6.19753 1.25306Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/CircledError.tsx
import { jsx as jsx51, jsxs as jsxs33 } from "react/jsx-runtime";
var CircledErrorIcon = (props) => {
  return /* @__PURE__ */ jsxs33(Svg, __spreadProps(__spreadValues({ viewBox: "0 0 17 16", defaultLabel: "Feilmeldingssirkelsirkel" }, props), { children: [
    /* @__PURE__ */ jsx51("circle", { cx: "8.22852", cy: "8", r: "7", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
    /* @__PURE__ */ jsx51("path", { d: "M10.2794 4.23316C10.58 3.91109 11.151 3.95551 11.5547 4.33237C11.9585 4.70923 12.042 5.27583 11.7414 5.5979L6.00642 11.7417C5.70578 12.0637 5.13478 12.0193 4.73105 11.6425C4.32733 11.2656 4.24376 10.699 4.54441 10.3769L10.2794 4.23316Z" }),
    /* @__PURE__ */ jsx51("path", { d: "M11.9211 10.157C12.2327 10.4685 12.1686 11.0377 11.7781 11.4282C11.3876 11.8187 10.8185 11.8827 10.5069 11.5712L4.56404 5.62831C4.2525 5.31677 4.31653 4.74763 4.70706 4.35711C5.09758 3.96658 5.66672 3.90256 5.97826 4.2141L11.9211 10.157Z" })
  ] }));
};

// ../udir-lisa/src/components/Icon/icons/Expand.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
var ExpandIcon = (props) => {
  return /* @__PURE__ */ jsx52(Svg, __spreadProps(__spreadValues({ viewBox: "4 4 16 16", defaultLabel: "Ekspander" }, props), { children: /* @__PURE__ */ jsx52(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.75 4.5C12.75 4.08579 13.0857 3.75 13.5 3.75L19.5 3.75C19.6989 3.75 19.8896 3.82902 20.0303 3.96967C20.171 4.11032 20.25 4.30109 20.25 4.5L20.25 10.5C20.25 10.9142 19.9142 11.25 19.5 11.25C19.0858 11.25 18.75 10.9142 18.75 10.5L18.75 6.31065L14.0303 11.0303C13.7374 11.3232 13.2625 11.3232 12.9696 11.0303C12.6767 10.7374 12.6767 10.2626 12.9696 9.96967L17.6893 5.25L13.5 5.25C13.0857 5.25 12.75 4.91421 12.75 4.5ZM4.49997 12.75C4.91418 12.75 5.24997 13.0858 5.24997 13.5L5.24997 17.6893L9.96962 12.9697C10.2625 12.6768 10.7374 12.6768 11.0303 12.9697C11.3232 13.2626 11.3232 13.7374 11.0303 14.0303L6.31062 18.75L10.5 18.75C10.9142 18.75 11.25 19.0858 11.25 19.5C11.25 19.9142 10.9142 20.25 10.5 20.25L4.49997 20.25C4.30106 20.25 4.11029 20.171 3.96964 20.0303C3.82899 19.8897 3.74997 19.6989 3.74997 19.5L3.74997 13.5C3.74997 13.0858 4.08576 12.75 4.49997 12.75Z",
      fill: "#currentColor"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/icons/Sidebar.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var SidebarIcon = (props) => {
  return /* @__PURE__ */ jsx53(Svg, __spreadProps(__spreadValues({ viewBox: "4 4 16 16", defaultLabel: "Sidefelt" }, props), { children: /* @__PURE__ */ jsx53(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4V20C3.25 20.4142 3.58579 20.75 4 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20V4C20.75 3.58579 20.4142 3.25 20 3.25H4ZM8.25 19.25L8.25 4.75H4.75V19.25H8.25ZM9.75 19.25L9.75 4.75H19.25V19.25H9.75Z",
      fill: "currentColor"
    }
  ) }));
};

// ../udir-lisa/src/components/Icon/IconTypes.ts
var regularIcons = {
  arrow: ArrowIcon,
  arrowThick: ArrowThickIcon,
  building: BuildingIcon,
  calendar: CalendarIcon,
  checkmark: CheckmarkIcon,
  checkmarkCircle: CheckmarkCircleIcon,
  chevron: ChevronIcon,
  circle: CircleIcon,
  circledChevron: CircledChevronIcon,
  circledInfo: CircledInfoIcon,
  copy: Copy,
  document: DocumentIcon,
  dots: DotsIcon,
  download: DownloadIcon,
  edit: EditIcon,
  exit: ExitIcon,
  externalLink: ExternalLinkIcon,
  eye: EyeIcon,
  filter: FilterIcon,
  clearFilter: ClearFilterIcon,
  home: HomeIcon,
  link: LinkIcon,
  linkBroken: LinkBrokenIcon,
  locked: LockedIcon,
  mail: MailIcon,
  monitor: MonitorIcon,
  mouseClick: MouseClickIcon,
  plus: PlusIcon,
  print: PrintIcon,
  redo: RedoIcon,
  refresh: RefreshIcon,
  search: SearchIcon,
  sort: SortIcon,
  shield: ShieldIcon,
  stopwatch: StopwatchIcon,
  trash: TrashIcon,
  udirArrow: UdirArrowIcon,
  unlocked: UnlockedIcon,
  user: UserIcon,
  userFilled: UserFilledIcon,
  warning: WarningIcon,
  circledError: CircledErrorIcon,
  expand: ExpandIcon,
  sidebar: SidebarIcon
};
var smallIcons = {
  checkmark_small: SmallCheckmarkIcon,
  circle_small: SmallCircleIcon,
  line_small: SmallLineIcon,
  questionmark_small: SmallQuestionmarkIcon,
  exit_small: SmallExitIcon
};
var availableIcons = __spreadValues(__spreadValues({}, regularIcons), smallIcons);

// ../udir-lisa/src/components/Icon/Icon.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var Icon = (_a) => {
  var _b = _a, { type } = _b, props = __objRest(_b, ["type"]);
  const IconComponent = availableIcons[type];
  return /* @__PURE__ */ jsx54(IconComponent, __spreadValues({}, props));
};

// ../udir-lisa/src/components/Layout/Flex.tsx
import styled5 from "styled-components";

// ../udir-lisa/src/utils/withTransientProps.ts
import styled4 from "styled-components";
var withTransientProps = (styledComponent, transientProps2) => {
  const styledProxy = styled4(styledComponent).withConfig({
    shouldForwardProp: (prop, defaultValidator) => {
      if (defaultValidator === void 0 || typeof defaultValidator !== "function") {
        return !transientProps2.includes(prop);
      }
      return !transientProps2.includes(prop) && defaultValidator(prop);
    }
  })``;
  return styledProxy;
};

// ../udir-lisa/src/components/Layout/Flex.tsx
var AlignValues = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch"
};
var JustifyValues = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  "space-around": "space-around",
  "space-between": "space-between"
};
var FlexCommon = styled5.div`
	display: flex;
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	flex-wrap: ${(props) => props.wrap};
	justify-content: ${(props) => {
  var _a;
  return JustifyValues[(_a = props.halign) != null ? _a : "start"];
}};
	align-items: ${(props) => {
  var _a;
  return AlignValues[(_a = props.valign) != null ? _a : "center"];
}};
	gap: ${(props) => props.gap && rem(props.gap)};
`;
var transientProps = ["width", "height", "valign", "halign", "wrap", "marginBetween"];
var FlexCommonWithTransientProps = withTransientProps(FlexCommon, transientProps);
var FlexRow = styled5(FlexCommonWithTransientProps)`
	> :not(:last-child) {
		margin-right: ${(props) => props.marginBetween && rem(props.marginBetween)};
	}
`;
FlexRow.defaultProps = { valign: "center", halign: "start" };
var FlexColumn = styled5(FlexCommonWithTransientProps)`
	flex-direction: column;
	> :not(:last-child) {
		margin-bottom: ${(props) => props.marginBetween && rem(props.marginBetween)};
	}
`;
FlexColumn.defaultProps = { valign: "stretch", halign: "start" };
var FlexGrow = styled5.div`
	flex: 1;
`;

// ../udir-lisa/src/shared/components/ErrorText.tsx
import { jsx as jsx55, jsxs as jsxs34 } from "react/jsx-runtime";
var ErrorText = (props) => {
  const { colorTheme = "light" } = props;
  const iconColor = semanticColors.error.icon(colorTheme);
  return /* @__PURE__ */ jsx55(StyledErrorText, { id: props.id, "aria-live": "polite", "aria-hidden": !props.errorMessage, colorTheme, children: props.errorMessage && /* @__PURE__ */ jsxs34(StyledFlexRow, { gap: 8, children: [
    /* @__PURE__ */ jsx55(Icon, { type: "warning", iconColor }),
    /* @__PURE__ */ jsx55("span", { children: props.errorMessage })
  ] }) });
};
var StyledErrorText = styled6.span`
	${textStyles.labelBold}
	color: ${(props) => semanticColors.error.text(props.colorTheme)};
	${shakeEffect}
`;
var StyledFlexRow = styled6(FlexRow)`
	${margin("top", 8)}
`;

// ../udir-lisa/src/shared/components/FormComponentWrapper.tsx
import styled7 from "styled-components";
var FormComponentWrapper2 = styled7.div`
	${LabelWithErrorShake} {
		${padding("bottom", 8)}
	}
`;

// ../udir-lisa/src/components/TextArea/TextArea.tsx
import { jsx as jsx56, jsxs as jsxs35 } from "react/jsx-runtime";
var defaultProps3 = {
  disabled: false,
  height: 150,
  resizable: false
};
var useTextArea = (props) => {
  const { disabled = defaultProps3.disabled, height = defaultProps3.height } = props;
  const hasErrorMessage = !!props.errorMessage;
  const id = useId();
  const errorId = `${id}-error`;
  return {
    label: /* @__PURE__ */ jsxs35(LabelWithErrorShake, { htmlFor: id, hasErrorMessage, visuallyHidden: props.hideLabel, children: [
      props.label,
      props.description && /* @__PURE__ */ jsx56(TextBlockSpan, { textStyle: "label", children: props.description })
    ] }),
    textArea: /* @__PURE__ */ jsx56(StyledTextAreaContainer, { hasErrorMessage, $disabled: disabled, children: /* @__PURE__ */ jsx56(
      StyledTextArea,
      {
        id,
        $height: height,
        resizable: props.resizable,
        placeholder: props.placeholder,
        value: props.value,
        disabled,
        onChange: props.handleChange,
        "aria-invalid": hasErrorMessage,
        "aria-errormessage": hasErrorMessage ? errorId : void 0,
        name: props.name
      }
    ) }),
    errorMessage: /* @__PURE__ */ jsx56(ErrorText, { id: errorId, errorMessage: props.errorMessage })
  };
};
var TextArea = (props) => {
  const { label, textArea: textarea, errorMessage } = useTextArea(props);
  return /* @__PURE__ */ jsxs35(FlexWrapper, { className: props.className, children: [
    label,
    textarea,
    errorMessage
  ] });
};
TextArea.defaultProps = defaultProps3;
var StyledTextAreaContainer = styled8.div`
	${inputContainerCss}
	display: flex;
	${(props) => props.$height && `height: ${props.$height}px;`}
	${(props) => props.hasErrorMessage && shakeEffect};
`;
var StyledTextArea = styled8.textarea`
	${inputCss}
	flex: 1;
	${padding(12, 16)}
	${(props) => props.resizable === false && `resize: none;`};
	${(props) => props.$height && `height: ${props.$height}px`};
`;
var FlexWrapper = styled8(FormComponentWrapper2)`
	display: flex;
	flex-direction: column;
`;

// src/components/FormTextArea.tsx
import { jsxs as jsxs36 } from "react/jsx-runtime";
function FormTextArea(props) {
  const { label, textArea, errorMessage } = useFormTextArea(props);
  return /* @__PURE__ */ jsxs36(FlexWrapper2, { className: props.className, children: [
    label,
    textArea,
    errorMessage
  ] });
}
function useFormTextArea(props) {
  var _b;
  const _a = props, { name, control, rules } = _a, textAreaProps = __objRest(_a, ["name", "control", "rules"]);
  const { field, fieldState } = useController4({ name, control, rules });
  const { label, textArea, errorMessage } = useTextArea(__spreadProps(__spreadValues({}, textAreaProps), {
    // @ts-ignore
    value: field.value,
    handleChange: field.onChange,
    // @ts-ignore
    errorMessage: (_b = fieldState == null ? void 0 : fieldState.error) == null ? void 0 : _b.message,
    name
  }));
  return {
    label,
    textArea,
    errorMessage
  };
}
var FlexWrapper2 = styled9(FormComponentWrapper3)`
	display: flex;
	flex-direction: column;
`;
export {
  FormCheckbox,
  FormDatepicker,
  FormInputField,
  FormSelect,
  FormTextArea,
  useFormDatepicker,
  useFormInputField,
  useFormSelect,
  useFormTextArea
};
